/******/ ;(function () {
  // webpackBootstrap
  /******/ var __webpack_modules__ = {
    /***/ 7345: /***/ function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
      'use strict'
      __webpack_require__.r(__webpack_exports__)
      /* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ =
        __webpack_require__(4942)
      /* provided dependency */ var MinimogSettings = __webpack_require__(4558)['MinimogSettings']

      class I18N {
        constructor() {
          var _this = this

          ;(0, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ /* ["default"] */.Z)(
            this,
            'shop_locale',
            MinimogSettings.shop_locale?.current || 'en'
          )

          ;(0, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ /* ["default"] */.Z)(
            this,
            'locales',
            {
              default: {
                date_format: 'MM/dd/yyyy',
                add_button: 'Add',
                added_button: 'Added',
                bundle_button: 'Add selected item(s)',
                bundle_saved: 'Saved',
                bundle_select: 'Select',
                bundle_selected: 'Selected',
                bundle_this_item: 'This item',
                bundle_total: 'Total price',
                checkout: 'Checkout',
                discount_summary: 'You will get <strong>{discount_value} OFF</strong> on each product',
                discount_title: 'SPECIAL OFFER',
                free: 'FREE',
                incart_title: 'Customers also bought with "{product_title}"',
                prepurchase_added: 'You just added',
                prepurchase_title: 'Frequently bought with "{product_title}"',
                qty_discount_note: 'on each product',
                qty_discount_title: '{item_count} item(s) get {discount_value} OFF',
                sizechart_button: 'Size chart',
                field_name: 'Enter your name',
                field_email: 'Enter your email',
                field_birthday: 'Date of birth',
                discount_noti: '* Discount will be calculated and applied at checkout',
                fox_discount_noti: `* You are entitled to 1 discount offer of <span>{price}</span> (<span>{discount_title}</span>). This offer <b>can't be combined</b> with any other discount you add here!`,
                bis_open: 'Notify me when available',
                bis_heading: 'Back in stock alert 📬',
                bis_desc: 'We will send you a notification as soon as this product is available again.',
                bis_submit: 'Notify me',
                bis_email: 'Your email',
                bis_name: 'Your name',
                bis_phone: 'Your phone number',
                bis_note: 'Your note',
                bis_signup: 'Email me with news and offers',
                bis_thankyou: "Thank you! We'll send you an email when this product is available!",
                preorder_discount_title: '🎁 Preorder now to get <strong>{discount_value} OFF</strong>',
                preorder_shipping_note: '🚚 Item will be delivered on or before <strong>{eta}</strong>',
                preorder_end_note: '🔥 Preorder will end at <strong>{end_time}</strong>'
              }
            }
          )

          ;(0, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ /* ["default"] */.Z)(
            this,
            'tr',
            function (key) {
              let _params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}

              const { locales, shop_locale } = _this
              let text =
                locales[shop_locale]?.[key] || locales['default'][key] || `Foxkit: translation missing for ${key}!`
              const params = Object.keys(_params)

              if (params.length) {
                Object.entries(_params).forEach((_ref) => {
                  let [k, v] = _ref
                  return (text = text.replace(`{${k}}`, v))
                })
              }

              return text
            }
          )

          ;(0, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ /* ["default"] */.Z)(
            this,
            'setLocales',
            (locale, data) => {
              this.locales[locale] = data
            }
          )
        }
      }

      const i18n = window.__i18n || new I18N()
      window.__i18n = window.__i18n || i18n
      /* harmony default export */ __webpack_exports__['default'] = i18n

      /***/
    },

    /***/ 4558: /***/ function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
      'use strict'
      __webpack_require__.r(__webpack_exports__)
      /* harmony export */ __webpack_require__.d(__webpack_exports__, {
        /* harmony export */ MinimogEvents: function () {
          return /* binding */ MinimogEvents
        },
        /* harmony export */ MinimogTheme: function () {
          return /* binding */ MinimogTheme
        },
        /* harmony export */ MinimogSettings: function () {
          return /* binding */ MinimogSettings
        },
        /* harmony export */ MinimogStrings: function () {
          return /* binding */ MinimogStrings
        },
        /* harmony export */ MinimogLibs: function () {
          return /* binding */ MinimogLibs
        }
        /* harmony export */
      })
      /* harmony import */ var _utils_events__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8971)

      window.MinimogEvents =
        window.MinimogEvents || new _utils_events__WEBPACK_IMPORTED_MODULE_0__ /* ["default"] */.Z()
      window._ThemeEvent = window.MinimogEvents
      const MinimogEvents = window.MinimogEvents
      const MinimogTheme = window.MinimogTheme || {}
      const MinimogSettings = window.MinimogSettings || {}
      const MinimogStrings = window.MinimogStrings || {}
      const MinimogLibs = window.MinimogLibs || {}

      /***/
    },

    /***/ 6295: /***/ function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
      'use strict'
      __webpack_require__.r(__webpack_exports__)
      /* harmony import */ var mdn_polyfills_Node_prototype_append_js__WEBPACK_IMPORTED_MODULE_0__ =
        __webpack_require__(2422)
      /* harmony import */ var mdn_polyfills_Node_prototype_append_js__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/ __webpack_require__.n(mdn_polyfills_Node_prototype_append_js__WEBPACK_IMPORTED_MODULE_0__)

      class JSX {
        constructor() {
          this.component = this.component.bind(this)
          return this.component
        }

        component(tagName, attrs) {
          for (
            var _len = arguments.length, children = new Array(_len > 2 ? _len - 2 : 0), _key = 2;
            _key < _len;
            _key++
          ) {
            children[_key - 2] = arguments[_key]
          }

          if (typeof tagName === 'function') {
            // Override children
            return tagName({ ...attrs, children })
          }

          if (children) {
            children = children.filter((val) => val !== null)
          }

          if (attrs) {
            if (attrs.class) {
              attrs.className = attrs.class
            }

            delete attrs.children
          } // Normal DOM node tagName

          function createWithAttrs(tagName, attrs) {
            attrs = attrs || {}
            let elem = document.createElement(tagName)

            try {
              elem = Object.assign(elem, attrs)
            } catch {
              const attrKeys = Object.keys(attrs)

              for (let i = 0; i < attrKeys.length; i++) {
                if (attrs[i] !== 'dataSet') {
                  elem.setAttribute(attrKeys[i], attrs[attrKeys[i]])
                }
              }
            }

            return elem
          }

          let elem = tagName !== 'fragment' ? createWithAttrs(tagName, attrs) : document.createDocumentFragment() // Evaluate SVG DOM node tagName
          // All svg inner tags: https://developer.mozilla.org/en-US/docs/Web/SVG/Element

          const svgInnerTags = ['svg', 'path', 'rect', 'text', 'circle', 'g']

          if (svgInnerTags.indexOf(tagName) !== -1) {
            elem = document.createElementNS('http://www.w3.org/2000/svg', tagName)

            for (const key in attrs) {
              const attrName = key === 'className' ? 'class' : key
              elem.setAttribute(attrName, attrs[key])
            }
          } // Populate children to created DOM Node

          for (const child of children) {
            if (Array.isArray(child)) {
              elem.append(...child)
            } else {
              elem.append(child)
            }
          } // After elements are created

          if (attrs?.dataSet) {
            for (const key in attrs.dataSet) {
              if (Object.prototype.hasOwnProperty.call(attrs.dataSet, key)) {
                elem.dataset[key] = attrs.dataSet[key]
              }
            }
          }

          if (attrs && !window.__aleartedJSXData) {
            if (Object.keys(attrs).find((key) => key.match(/^data-/))) {
              console.trace(`Your "${tagName}" component uses a data-* attribute! Use dataSet instead!!`)
              alert(
                'Do not use data-* in your JSX component! Use dataSet instead!! - Check the console.trace for more info'
              )
              window.__aleartedJSXData = true
            }
          }

          if (attrs?.ref) {
            // Create a custom reference to DOM node
            if (typeof attrs.ref === 'function') {
              attrs.ref(elem)
            } else {
              attrs.ref = elem
            }
          }

          if (attrs?.on) {
            Object.entries(attrs.on).forEach((_ref) => {
              let [event, handler] = _ref
              elem.addEventListener(event, handler)
            })
          } // Append style attributes to created DOM node

          if (attrs?.style) {
            Object.entries(attrs.style).forEach((_ref2) => {
              let [property, value] = _ref2
              elem.style.setProperty(property, value)
            }) // Object.assign(elem.style, attrs.style);
          }

          return elem
        }
      }

      /* harmony default export */ __webpack_exports__['default'] = new JSX()

      /***/
    },

    /***/ 8971: /***/ function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
      'use strict'
      /* harmony export */ __webpack_require__.d(__webpack_exports__, {
        /* harmony export */ X: function () {
          return /* binding */ addEventDelegate
        },
        /* harmony export */ Z: function () {
          return /* binding */ Event
        }
        /* harmony export */
      })
      const addEventDelegate = (_ref) => {
        let { context = document.documentElement, event = 'click', selector, handler, capture = false } = _ref

        const listener = function (e) {
          // loop parent nodes from the target to the delegation node
          for (let target = e.target; target && target !== this; target = target.parentNode) {
            if (target.matches(selector)) {
              handler.call(target, e, target)
              break
            }
          }
        }

        context.addEventListener(event, listener, capture)
        return () => {
          context.removeEventListener(event, listener, capture)
        }
      }
      class Event {
        constructor() {
          this.events = {}
        }

        get evts() {
          return Object.keys(this.events)
        }

        subscribe(event, handler) {
          this.events[event] = this.events[event] || []
          this.events[event].push(handler)
          return () => this.unSubscribe(event, handler)
        }

        unSubscribe(event, handler) {
          const handlers = this.events[event]

          if (handlers && Array.isArray(handlers)) {
            for (let i = 0; i < handlers.length; i++) {
              if (handlers[i] === handler) {
                handlers.splice(i, 1)
                break
              }
            }
          }
        }

        emit(event) {
          for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key]
          }

          console.groupCollapsed(`Event emitted: ${event}`)
          console.trace()
          console.groupEnd()
          ;(this.events[event] || []).forEach((handler) => {
            handler(...args)
          })
        }
      }

      /***/
    },

    /***/ 2422: /***/ function () {
      !(function () {
        function t() {
          var e = Array.prototype.slice.call(arguments),
            n = document.createDocumentFragment()
          e.forEach(function (e) {
            var t = e instanceof Node
            n.appendChild(t ? e : document.createTextNode(String(e)))
          }),
            this.appendChild(n)
        }

        ;[Element.prototype, Document.prototype, DocumentFragment.prototype].forEach(function (e) {
          e.hasOwnProperty('append') ||
            Object.defineProperty(e, 'append', {
              configurable: !0,
              enumerable: !0,
              writable: !0,
              value: t
            })
        })
      })()

      /***/
    },

    /***/ 643: /***/ function (module) {
      var COMPLETE = 'complete',
        CANCELED = 'canceled'

      function raf(task) {
        if ('requestAnimationFrame' in window) {
          return window.requestAnimationFrame(task)
        }

        setTimeout(task, 16)
      }

      function setElementScroll(element, x, y) {
        Math.max(0, x)
        Math.max(0, y)

        if (element.self === element) {
          element.scrollTo(x, y)
        } else {
          element.scrollLeft = x
          element.scrollTop = y
        }
      }

      function getTargetScrollLocation(scrollSettings, parent) {
        var align = scrollSettings.align,
          target = scrollSettings.target,
          targetPosition = target.getBoundingClientRect(),
          parentPosition,
          x,
          y,
          differenceX,
          differenceY,
          targetWidth,
          targetHeight,
          leftAlign = align && align.left != null ? align.left : 0.5,
          topAlign = align && align.top != null ? align.top : 0.5,
          leftOffset = align && align.leftOffset != null ? align.leftOffset : 0,
          topOffset = align && align.topOffset != null ? align.topOffset : 0,
          leftScalar = leftAlign,
          topScalar = topAlign

        if (scrollSettings.isWindow(parent)) {
          targetWidth = Math.min(targetPosition.width, parent.innerWidth)
          targetHeight = Math.min(targetPosition.height, parent.innerHeight)
          x = targetPosition.left + parent.pageXOffset - parent.innerWidth * leftScalar + targetWidth * leftScalar
          y = targetPosition.top + parent.pageYOffset - parent.innerHeight * topScalar + targetHeight * topScalar
          x -= leftOffset
          y -= topOffset
          x = scrollSettings.align.lockX ? parent.pageXOffset : x
          y = scrollSettings.align.lockY ? parent.pageYOffset : y
          differenceX = x - parent.pageXOffset
          differenceY = y - parent.pageYOffset
        } else {
          targetWidth = targetPosition.width
          targetHeight = targetPosition.height
          parentPosition = parent.getBoundingClientRect()
          var offsetLeft = targetPosition.left - (parentPosition.left - parent.scrollLeft)
          var offsetTop = targetPosition.top - (parentPosition.top - parent.scrollTop)
          x = offsetLeft + targetWidth * leftScalar - parent.clientWidth * leftScalar
          y = offsetTop + targetHeight * topScalar - parent.clientHeight * topScalar
          x -= leftOffset
          y -= topOffset
          x = Math.max(Math.min(x, parent.scrollWidth - parent.clientWidth), 0)
          y = Math.max(Math.min(y, parent.scrollHeight - parent.clientHeight), 0)
          x = scrollSettings.align.lockX ? parent.scrollLeft : x
          y = scrollSettings.align.lockY ? parent.scrollTop : y
          differenceX = x - parent.scrollLeft
          differenceY = y - parent.scrollTop
        }

        return {
          x: x,
          y: y,
          differenceX: differenceX,
          differenceY: differenceY
        }
      }

      function animate(parent) {
        var scrollSettings = parent._scrollSettings

        if (!scrollSettings) {
          return
        }

        var maxSynchronousAlignments = scrollSettings.maxSynchronousAlignments
        var location = getTargetScrollLocation(scrollSettings, parent),
          time = Date.now() - scrollSettings.startTime,
          timeValue = Math.min((1 / scrollSettings.time) * time, 1)

        if (scrollSettings.endIterations >= maxSynchronousAlignments) {
          setElementScroll(parent, location.x, location.y)
          parent._scrollSettings = null
          return scrollSettings.end(COMPLETE)
        }

        var easeValue = 1 - scrollSettings.ease(timeValue)
        setElementScroll(
          parent,
          location.x - location.differenceX * easeValue,
          location.y - location.differenceY * easeValue
        )

        if (time >= scrollSettings.time) {
          scrollSettings.endIterations++ // Align ancestor synchronously

          scrollSettings.scrollAncestor && animate(scrollSettings.scrollAncestor)
          animate(parent)
          return
        }

        raf(animate.bind(null, parent))
      }

      function defaultIsWindow(target) {
        return target.self === target
      }

      function transitionScrollTo(target, parent, settings, scrollAncestor, callback) {
        var idle = !parent._scrollSettings,
          lastSettings = parent._scrollSettings,
          now = Date.now(),
          cancelHandler,
          passiveOptions = {
            passive: true
          }

        if (lastSettings) {
          lastSettings.end(CANCELED)
        }

        function end(endType) {
          parent._scrollSettings = null

          if (parent.parentElement && parent.parentElement._scrollSettings) {
            parent.parentElement._scrollSettings.end(endType)
          }

          if (settings.debug) {
            console.log('Scrolling ended with type', endType, 'for', parent)
          }

          callback(endType)

          if (cancelHandler) {
            parent.removeEventListener('touchstart', cancelHandler, passiveOptions)
            parent.removeEventListener('wheel', cancelHandler, passiveOptions)
          }
        }

        var maxSynchronousAlignments = settings.maxSynchronousAlignments

        if (maxSynchronousAlignments == null) {
          maxSynchronousAlignments = 3
        }

        parent._scrollSettings = {
          startTime: now,
          endIterations: 0,
          target: target,
          time: settings.time,
          ease: settings.ease,
          align: settings.align,
          isWindow: settings.isWindow || defaultIsWindow,
          maxSynchronousAlignments: maxSynchronousAlignments,
          end: end,
          scrollAncestor
        }

        if (!('cancellable' in settings) || settings.cancellable) {
          cancelHandler = end.bind(null, CANCELED)
          parent.addEventListener('touchstart', cancelHandler, passiveOptions)
          parent.addEventListener('wheel', cancelHandler, passiveOptions)
        }

        if (idle) {
          animate(parent)
        }

        return cancelHandler
      }

      function defaultIsScrollable(element) {
        return (
          'pageXOffset' in element ||
          ((element.scrollHeight !== element.clientHeight || element.scrollWidth !== element.clientWidth) &&
            getComputedStyle(element).overflow !== 'hidden')
        )
      }

      function defaultValidTarget() {
        return true
      }

      function findParentElement(el) {
        if (el.assignedSlot) {
          return findParentElement(el.assignedSlot)
        }

        if (el.parentElement) {
          if (el.parentElement.tagName === 'BODY') {
            return el.parentElement.ownerDocument.defaultView || el.parentElement.ownerDocument.ownerWindow
          }

          return el.parentElement
        }

        if (el.getRootNode) {
          var parent = el.getRootNode()

          if (parent.nodeType === 11) {
            return parent.host
          }
        }
      }

      module.exports = function (target, settings, callback) {
        if (!target) {
          return
        }

        if (typeof settings === 'function') {
          callback = settings
          settings = null
        }

        if (!settings) {
          settings = {}
        }

        settings.time = isNaN(settings.time) ? 1000 : settings.time

        settings.ease =
          settings.ease ||
          function (v) {
            return 1 - Math.pow(1 - v, v / 2)
          }

        settings.align = settings.align || {}
        var parent = findParentElement(target),
          parents = 1

        function done(endType) {
          parents--

          if (!parents) {
            callback && callback(endType)
          }
        }

        var validTarget = settings.validTarget || defaultValidTarget
        var isScrollable = settings.isScrollable

        if (settings.debug) {
          console.log('About to scroll to', target)

          if (!parent) {
            console.error('Target did not have a parent, is it mounted in the DOM?')
          }
        }

        var scrollingElements = []

        while (parent) {
          if (settings.debug) {
            console.log('Scrolling parent node', parent)
          }

          if (
            validTarget(parent, parents) &&
            (isScrollable ? isScrollable(parent, defaultIsScrollable) : defaultIsScrollable(parent))
          ) {
            parents++
            scrollingElements.push(parent)
          }

          parent = findParentElement(parent)

          if (!parent) {
            done(COMPLETE)
            break
          }
        }

        return scrollingElements.reduce(
          (cancel, parent, index) => transitionScrollTo(target, parent, settings, scrollingElements[index + 1], done),
          null
        )
      }

      /***/
    },

    /***/ 4942: /***/ function (__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
      'use strict'
      /* harmony export */ __webpack_require__.d(__webpack_exports__, {
        /* harmony export */ Z: function () {
          return /* binding */ _defineProperty
        }
        /* harmony export */
      })
      function _defineProperty(obj, key, value) {
        if (key in obj) {
          Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
          })
        } else {
          obj[key] = value
        }

        return obj
      }

      /***/
    }

    /******/
  }
  /************************************************************************/
  /******/ // The module cache
  /******/ var __webpack_module_cache__ = {}
  /******/
  /******/ // The require function
  /******/ function __webpack_require__(moduleId) {
    /******/ // Check if module is in cache
    /******/ var cachedModule = __webpack_module_cache__[moduleId]
    /******/ if (cachedModule !== undefined) {
      /******/ return cachedModule.exports
      /******/
    }
    /******/ // Create a new module (and put it into the cache)
    /******/ var module = (__webpack_module_cache__[moduleId] = {
      /******/ // no module.id needed
      /******/ // no module.loaded needed
      /******/ exports: {}
      /******/
    })
    /******/
    /******/ // Execute the module function
    /******/ __webpack_modules__[moduleId](module, module.exports, __webpack_require__)
    /******/
    /******/ // Return the exports of the module
    /******/ return module.exports
    /******/
  }
  /******/
  /************************************************************************/
  /******/ /* webpack/runtime/compat get default export */
  /******/ !(function () {
    /******/ // getDefaultExport function for compatibility with non-harmony modules
    /******/ __webpack_require__.n = function (module) {
      /******/ var getter =
        module && module.__esModule
          ? /******/ function () {
              return module['default']
            }
          : /******/ function () {
              return module
            }
      /******/ __webpack_require__.d(getter, { a: getter })
      /******/ return getter
      /******/
    }
    /******/
  })()
  /******/
  /******/ /* webpack/runtime/define property getters */
  /******/ !(function () {
    /******/ // define getter functions for harmony exports
    /******/ __webpack_require__.d = function (exports, definition) {
      /******/ for (var key in definition) {
        /******/ if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
          /******/ Object.defineProperty(exports, key, { enumerable: true, get: definition[key] })
          /******/
        }
        /******/
      }
      /******/
    }
    /******/
  })()
  /******/
  /******/ /* webpack/runtime/hasOwnProperty shorthand */
  /******/ !(function () {
    /******/ __webpack_require__.o = function (obj, prop) {
      return Object.prototype.hasOwnProperty.call(obj, prop)
    }
    /******/
  })()
  /******/
  /******/ /* webpack/runtime/make namespace object */
  /******/ !(function () {
    /******/ // define __esModule on exports
    /******/ __webpack_require__.r = function (exports) {
      /******/ if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
        /******/ Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' })
        /******/
      }
      /******/ Object.defineProperty(exports, '__esModule', { value: true })
      /******/
    }
    /******/
  })()
  /******/
  /************************************************************************/
  var __webpack_exports__ = {}
  // This entry need to be wrapped in an IIFE because it need to be in strict mode.
  !(function () {
    'use strict'

    // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
    var defineProperty = __webpack_require__(4942) // CONCATENATED MODULE: ./src/js/components/Spinner.jsx
    /* provided dependency */ var createElement = __webpack_require__(6295)['default']
    /* harmony default export */ function Spinner(_ref) {
      let { className = '' } = _ref
      return createElement(
        'svg',
        {
          className: `animate-spin hidden w-[20px] h-[20px] ${className}`,
          xmlns: 'http://www.w3.org/2000/svg',
          viewBox: '0 0 24 24',
          fill: 'none'
        },
        createElement('circle', {
          className: 'opacity-25',
          cx: '12',
          cy: '12',
          r: '10',
          stroke: 'currentColor',
          'stroke-width': '4'
        }),
        createElement('path', {
          className: 'opacity-75',
          fill: 'currentColor',
          d: 'M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z'
        })
      )
    } // CONCATENATED MODULE: ./src/js/components/Modal.jsx
    /* provided dependency */ var Modal_createElement = __webpack_require__(6295)['default']
    function Modal_Modal(_ref) {
      let { wrapper_class = '' } = _ref
      return Modal_createElement(
        'div',
        {
          style: {
            '--tw-bg-opacity': '0.3'
          },
          className: `sf-modal sf-modal__wrapper fixed inset-0 px-5 bg-black flex items-center justify-center transition-opacity opacity-0 duration-200 ease-out ${wrapper_class}`
        },
        Modal_createElement(
          'div',
          {
            className: 'sf-modal__content bg-white relative rounded max-h-[90vh]'
          },
          Modal_createElement(
            'button',
            {
              className: 'sf-modal__close text-black absolute p-2 bg-white hover:bg-gray-300 rounded-full z-10'
            },
            Modal_createElement(
              'svg',
              {
                className: 'w-4 h-4',
                fill: 'none',
                stroke: 'currentColor',
                viewBox: '0 0 24 24',
                xmlns: 'http://www.w3.org/2000/svg'
              },
              Modal_createElement('path', {
                'stroke-linecap': 'round',
                'stroke-linejoin': 'round',
                'stroke-width': '2',
                d: 'M6 18L18 6M6 6l12 12'
              })
            )
          ),
          Modal_createElement('div', {
            className: 'sf-modal__content-inner'
          })
        )
      )
    }
    // EXTERNAL MODULE: ./src/js/utilities/events.js
    var events = __webpack_require__(8971) // CONCATENATED MODULE: ./src/js/modules/modal.js
    /* provided dependency */ var modal_createElement = __webpack_require__(6295)['default']

    // eslint-disable-next-line no-unused-vars

    class Modal {
      constructor(wrapper_class) {
        var _this = this

        ;(0, defineProperty /* default */.Z)(this, 'init', () => {
          ;(0, events /* addEventDelegate */.X)({
            selector: '.sf-modal__wrapper',
            handler: (e) => {
              if (e?.target === this.modal || e?.target?.closest('.sf-modal__close')) {
                this.close(e)
              }
            }
          })
        })

        ;(0, defineProperty /* default */.Z)(this, 'setSizes', function () {
          let sizes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''

          _this.resetSize()

          _this.sizes = sizes
          sizes.split(' ').forEach((size) => {
            _this.modalContent?.classList?.add(size)
          })
        })

        ;(0, defineProperty /* default */.Z)(this, 'setWidth', (width) => {
          this.modalContent.style.width = width
        })

        ;(0, defineProperty /* default */.Z)(this, 'resetSize', () => {
          if (this.sizes) {
            this.sizes.split(' ').forEach((size) => {
              this.modalContent?.classList?.remove(size)
            })
            this.sizes = ''
          }
        })

        ;(0, defineProperty /* default */.Z)(this, 'appendChild', (child) => {
          this?.modalContentInner?.appendChild(child)
          this.children = child
        })

        ;(0, defineProperty /* default */.Z)(this, 'removeChild', () => {
          this?.children?.remove()
        })

        ;(0, defineProperty /* default */.Z)(this, 'open', () => {
          document.documentElement.classList.add('prevent-scroll')
          document.body.appendChild(this.modal)
          setTimeout(() => this.modal.classList.add('opacity-100'))
          window.addEventListener('keydown', this.handleKeyDown)
        })

        ;(0, defineProperty /* default */.Z)(this, 'close', (e) => {
          e?.preventDefault()
          this.modal.classList.remove('opacity-100')
          window.removeEventListener('keydown', this.handleKeyDown)
          setTimeout(() => {
            this.modal.remove()
            this.removeChild()
            this.resetSize()
            this.modalContent.style.removeProperty('width')
            document.documentElement.classList.remove('prevent-scroll')
          }, this.transitionDuration)
        })

        ;(0, defineProperty /* default */.Z)(this, 'handleKeyDown', (e) => {
          // ESC
          if (e.keyCode === 27) {
            this.close()
          }
        })

        this.modal = modal_createElement(Modal_Modal, {
          wrapper_class: wrapper_class || undefined
        })
        this.modalContent = this.modal?.querySelector('.sf-modal__content')
        this.modalContentInner = this.modal?.querySelector('.sf-modal__content-inner')
        this.transitionDuration = 200
        this.init()
      }
    }

    /* harmony default export */ var modal = Modal // CONCATENATED MODULE: ./src/js/utilities/fetch.js
    /* provided dependency */ var fetch_createElement = __webpack_require__(6295)['default']
    const requestDefaultConfigs = {
      mode: 'same-origin',
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json'
      }
    }
    function getRequestDefaultConfigs() {
      return JSON.parse(JSON.stringify(requestDefaultConfigs))
    }
    const fetchJSON = function (url) {
      let config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getRequestDefaultConfigs()
      return fetch(url, config).then(function (response) {
        if (!response.ok) {
          throw response
        }

        return response.json()
      })
    }
    const cache = new Map()
    const fetchCache = function (url) {
      let config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getRequestDefaultConfigs()
      return new Promise((resolve, reject) => {
        let cached = cache.get(url)
        if (cached) return resolve(cached)
        fetch(url, config)
          .then((res) => {
            cached = res.text()
            cache.set(url, cached)
            resolve(cached)
          })
          .catch(reject)
      })
    }
    const sectionCache = new Map()
    const fetchSection = function (sectionId) {
      let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}
      const { url: _url, fromCache = false, params = {} } = options
      return new Promise((resolve, reject) => {
        const url = new URL(_url || window.location.href)
        url.searchParams.set('section_id', sectionId)
        Object.entries(params).forEach((_ref) => {
          let [k, v] = _ref
          return url.searchParams.set(k, v)
        })

        if (fromCache) {
          const cached = sectionCache.get(url)
          if (cached) return resolve(cached)
        }

        fetch(url, getRequestDefaultConfigs())
          .then((res) => {
            if (res.ok) return res.text()
            reject(`Failed to load section: ${sectionId}`)
          })
          .then((html) => {
            const div = fetch_createElement('div', null)
            div.innerHTML = html
            sectionCache.set(url, div)
            resolve(div)
          })
          .catch(reject)
      })
    }
    const cache2 = new Map()
    const fetchJsonCache = function (url) {
      let config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : requestDefaultConfigs
      return new Promise((resolve, reject) => {
        if (cache2.get(url)) {
          return resolve(cache2.get(url))
        }

        fetch(url, config)
          .then((res) => {
            if (res.ok) {
              const json = res.json()
              resolve(json)
              cache2.set(url, json)
              return json
            } else {
              reject(res)
            }
          })
          .catch(reject)
      })
    } // CONCATENATED MODULE: ./node_modules/@shopify/theme-currency/currency.js
    /**
     * Currency Helpers
     * -----------------------------------------------------------------------------
     * A collection of useful functions that help with currency formatting
     *
     * Current contents
     * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
     *
     */
    const moneyFormat = '${{amount}}'
    /**
     * Format money values based on your shop currency settings
     * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
     * or 3.00 dollars
     * @param  {String} format - shop money_format setting
     * @return {String} value - formatted value
     */

    function formatMoney(cents, format) {
      if (typeof cents === 'string') {
        cents = cents.replace('.', '')
      }

      let value = ''
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/
      const formatString = format || moneyFormat

      function formatWithDelimiters(number) {
        let precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2
        let thousands = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ','
        let decimal = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '.'

        if (isNaN(number) || number == null) {
          return 0
        }

        number = (number / 100.0).toFixed(precision)
        const parts = number.split('.')
        const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`)
        const centsAmount = parts[1] ? decimal + parts[1] : ''
        return dollarsAmount + centsAmount
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2)
          break

        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0)
          break

        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',')
          break

        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',')
          break
      }

      return formatString.replace(placeholderRegex, value)
    } // CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/requiredArgs/index.js
    function requiredArgs(required, args) {
      if (args.length < required) {
        throw new TypeError(
          required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present'
        )
      }
    } // CONCATENATED MODULE: ./node_modules/date-fns/esm/isDate/index.js
    /**
     * @name isDate
     * @category Common Helpers
     * @summary Is the given value a date?
     *
     * @description
     * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
     *
     * ### v2.0.0 breaking changes:
     *
     * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
     *
     * @param {*} value - the value to check
     * @returns {boolean} true if the given value is a date
     * @throws {TypeError} 1 arguments required
     *
     * @example
     * // For a valid date:
     * const result = isDate(new Date())
     * //=> true
     *
     * @example
     * // For an invalid date:
     * const result = isDate(new Date(NaN))
     * //=> true
     *
     * @example
     * // For some value:
     * const result = isDate('2014-02-31')
     * //=> false
     *
     * @example
     * // For an object:
     * const result = isDate({})
     * //=> false
     */

    function isDate(value) {
      requiredArgs(1, arguments)
      return (
        value instanceof Date ||
        (typeof value === 'object' && Object.prototype.toString.call(value) === '[object Date]')
      )
    } // CONCATENATED MODULE: ./node_modules/date-fns/esm/toDate/index.js
    /**
     * @name toDate
     * @category Common Helpers
     * @summary Convert the given argument to an instance of Date.
     *
     * @description
     * Convert the given argument to an instance of Date.
     *
     * If the argument is an instance of Date, the function returns its clone.
     *
     * If the argument is a number, it is treated as a timestamp.
     *
     * If the argument is none of the above, the function returns Invalid Date.
     *
     * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
     *
     * @param {Date|Number} argument - the value to convert
     * @returns {Date} the parsed date in the local time zone
     * @throws {TypeError} 1 argument required
     *
     * @example
     * // Clone the date:
     * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
     * //=> Tue Feb 11 2014 11:30:30
     *
     * @example
     * // Convert the timestamp to date:
     * const result = toDate(1392098430000)
     * //=> Tue Feb 11 2014 11:30:30
     */

    function toDate(argument) {
      requiredArgs(1, arguments)
      var argStr = Object.prototype.toString.call(argument) // Clone the date

      if (argument instanceof Date || (typeof argument === 'object' && argStr === '[object Date]')) {
        // Prevent the date to lose the milliseconds when passed to new Date() in IE10
        return new Date(argument.getTime())
      } else if (typeof argument === 'number' || argStr === '[object Number]') {
        return new Date(argument)
      } else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
          // eslint-disable-next-line no-console
          console.warn(
            "Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"
          ) // eslint-disable-next-line no-console

          console.warn(new Error().stack)
        }

        return new Date(NaN)
      }
    } // CONCATENATED MODULE: ./node_modules/date-fns/esm/isValid/index.js
    /**
     * @name isValid
     * @category Common Helpers
     * @summary Is the given date valid?
     *
     * @description
     * Returns false if argument is Invalid Date and true otherwise.
     * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
     * Invalid Date is a Date, whose time value is NaN.
     *
     * Time value of Date: http://es5.github.io/#x15.9.1.1
     *
     * ### v2.0.0 breaking changes:
     *
     * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
     *
     * - Now `isValid` doesn't throw an exception
     *   if the first argument is not an instance of Date.
     *   Instead, argument is converted beforehand using `toDate`.
     *
     *   Examples:
     *
     *   | `isValid` argument        | Before v2.0.0 | v2.0.0 onward |
     *   |---------------------------|---------------|---------------|
     *   | `new Date()`              | `true`        | `true`        |
     *   | `new Date('2016-01-01')`  | `true`        | `true`        |
     *   | `new Date('')`            | `false`       | `false`       |
     *   | `new Date(1488370835081)` | `true`        | `true`        |
     *   | `new Date(NaN)`           | `false`       | `false`       |
     *   | `'2016-01-01'`            | `TypeError`   | `false`       |
     *   | `''`                      | `TypeError`   | `false`       |
     *   | `1488370835081`           | `TypeError`   | `true`        |
     *   | `NaN`                     | `TypeError`   | `false`       |
     *
     *   We introduce this change to make *date-fns* consistent with ECMAScript behavior
     *   that try to coerce arguments to the expected type
     *   (which is also the case with other *date-fns* functions).
     *
     * @param {*} date - the date to check
     * @returns {Boolean} the date is valid
     * @throws {TypeError} 1 argument required
     *
     * @example
     * // For the valid date:
     * const result = isValid(new Date(2014, 1, 31))
     * //=> true
     *
     * @example
     * // For the value, convertable into a date:
     * const result = isValid(1393804800000)
     * //=> true
     *
     * @example
     * // For the invalid date:
     * const result = isValid(new Date(''))
     * //=> false
     */

    function isValid(dirtyDate) {
      requiredArgs(1, arguments)

      if (!isDate(dirtyDate) && typeof dirtyDate !== 'number') {
        return false
      }

      var date = toDate(dirtyDate)
      return !isNaN(Number(date))
    } // CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/formatDistance/index.js
    var formatDistanceLocale = {
      lessThanXSeconds: {
        one: 'less than a second',
        other: 'less than {{count}} seconds'
      },
      xSeconds: {
        one: '1 second',
        other: '{{count}} seconds'
      },
      halfAMinute: 'half a minute',
      lessThanXMinutes: {
        one: 'less than a minute',
        other: 'less than {{count}} minutes'
      },
      xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
      },
      aboutXHours: {
        one: 'about 1 hour',
        other: 'about {{count}} hours'
      },
      xHours: {
        one: '1 hour',
        other: '{{count}} hours'
      },
      xDays: {
        one: '1 day',
        other: '{{count}} days'
      },
      aboutXWeeks: {
        one: 'about 1 week',
        other: 'about {{count}} weeks'
      },
      xWeeks: {
        one: '1 week',
        other: '{{count}} weeks'
      },
      aboutXMonths: {
        one: 'about 1 month',
        other: 'about {{count}} months'
      },
      xMonths: {
        one: '1 month',
        other: '{{count}} months'
      },
      aboutXYears: {
        one: 'about 1 year',
        other: 'about {{count}} years'
      },
      xYears: {
        one: '1 year',
        other: '{{count}} years'
      },
      overXYears: {
        one: 'over 1 year',
        other: 'over {{count}} years'
      },
      almostXYears: {
        one: 'almost 1 year',
        other: 'almost {{count}} years'
      }
    }

    var formatDistance = function (token, count, options) {
      var result
      var tokenValue = formatDistanceLocale[token]

      if (typeof tokenValue === 'string') {
        result = tokenValue
      } else if (count === 1) {
        result = tokenValue.one
      } else {
        result = tokenValue.other.replace('{{count}}', count.toString())
      }

      if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          return 'in ' + result
        } else {
          return result + ' ago'
        }
      }

      return result
    }

    /* harmony default export */ var _lib_formatDistance = formatDistance // CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/_lib/buildFormatLongFn/index.js
    function buildFormatLongFn(args) {
      return function () {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {} // TODO: Remove String()

        var width = options.width ? String(options.width) : args.defaultWidth
        var format = args.formats[width] || args.formats[args.defaultWidth]
        return format
      }
    } // CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/formatLong/index.js
    var dateFormats = {
      full: 'EEEE, MMMM do, y',
      long: 'MMMM do, y',
      medium: 'MMM d, y',
      short: 'MM/dd/yyyy'
    }
    var timeFormats = {
      full: 'h:mm:ss a zzzz',
      long: 'h:mm:ss a z',
      medium: 'h:mm:ss a',
      short: 'h:mm a'
    }
    var dateTimeFormats = {
      full: "{{date}} 'at' {{time}}",
      long: "{{date}} 'at' {{time}}",
      medium: '{{date}}, {{time}}',
      short: '{{date}}, {{time}}'
    }
    var formatLong = {
      date: buildFormatLongFn({
        formats: dateFormats,
        defaultWidth: 'full'
      }),
      time: buildFormatLongFn({
        formats: timeFormats,
        defaultWidth: 'full'
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats,
        defaultWidth: 'full'
      })
    }
    /* harmony default export */ var _lib_formatLong = formatLong // CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/formatRelative/index.js
    var formatRelativeLocale = {
      lastWeek: "'last' eeee 'at' p",
      yesterday: "'yesterday at' p",
      today: "'today at' p",
      tomorrow: "'tomorrow at' p",
      nextWeek: "eeee 'at' p",
      other: 'P'
    }

    var formatRelative = function (token, _date, _baseDate, _options) {
      return formatRelativeLocale[token]
    }

    /* harmony default export */ var _lib_formatRelative = formatRelative // CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/_lib/buildLocalizeFn/index.js
    function buildLocalizeFn(args) {
      return function (dirtyIndex, dirtyOptions) {
        var options = dirtyOptions || {}
        var context = options.context ? String(options.context) : 'standalone'
        var valuesArray

        if (context === 'formatting' && args.formattingValues) {
          var defaultWidth = args.defaultFormattingWidth || args.defaultWidth
          var width = options.width ? String(options.width) : defaultWidth
          valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth]
        } else {
          var _defaultWidth = args.defaultWidth

          var _width = options.width ? String(options.width) : args.defaultWidth

          valuesArray = args.values[_width] || args.values[_defaultWidth]
        }

        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!

        return valuesArray[index]
      }
    } // CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/localize/index.js
    var eraValues = {
      narrow: ['B', 'A'],
      abbreviated: ['BC', 'AD'],
      wide: ['Before Christ', 'Anno Domini']
    }
    var quarterValues = {
      narrow: ['1', '2', '3', '4'],
      abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
      wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
    } // Note: in English, the names of days of the week and months are capitalized.
    // If you are making a new locale based on this one, check if the same is true for the language you're working on.
    // Generally, formatted dates should look like they are in the middle of a sentence,
    // e.g. in Spanish language the weekdays and months should be in the lowercase.

    var monthValues = {
      narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
      abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      wide: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
      ]
    }
    var dayValues = {
      narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
      short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
      abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
    }
    var dayPeriodValues = {
      narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
      },
      abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
      },
      wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
      }
    }
    var formattingDayPeriodValues = {
      narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
      },
      abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
      },
      wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
      }
    }

    var ordinalNumber = function (dirtyNumber, _options) {
      var number = Number(dirtyNumber) // If ordinal numbers depend on context, for example,
      // if they are different for different grammatical genders,
      // use `options.unit`.
      //
      // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
      // 'day', 'hour', 'minute', 'second'.

      var rem100 = number % 100

      if (rem100 > 20 || rem100 < 10) {
        switch (rem100 % 10) {
          case 1:
            return number + 'st'

          case 2:
            return number + 'nd'

          case 3:
            return number + 'rd'
        }
      }

      return number + 'th'
    }

    var localize = {
      ordinalNumber: ordinalNumber,
      era: buildLocalizeFn({
        values: eraValues,
        defaultWidth: 'wide'
      }),
      quarter: buildLocalizeFn({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function (quarter) {
          return quarter - 1
        }
      }),
      month: buildLocalizeFn({
        values: monthValues,
        defaultWidth: 'wide'
      }),
      day: buildLocalizeFn({
        values: dayValues,
        defaultWidth: 'wide'
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
      })
    }
    /* harmony default export */ var _lib_localize = localize // CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/_lib/buildMatchFn/index.js
    function buildMatchFn(args) {
      return function (string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}
        var width = options.width
        var matchPattern = (width && args.matchPatterns[width]) || args.matchPatterns[args.defaultMatchWidth]
        var matchResult = string.match(matchPattern)

        if (!matchResult) {
          return null
        }

        var matchedString = matchResult[0]
        var parsePatterns = (width && args.parsePatterns[width]) || args.parsePatterns[args.defaultParseWidth]
        var key = Array.isArray(parsePatterns)
          ? findIndex(parsePatterns, function (pattern) {
              return pattern.test(matchedString)
            })
          : findKey(parsePatterns, function (pattern) {
              return pattern.test(matchedString)
            })
        var value
        value = args.valueCallback ? args.valueCallback(key) : key
        value = options.valueCallback ? options.valueCallback(value) : value
        var rest = string.slice(matchedString.length)
        return {
          value: value,
          rest: rest
        }
      }
    }

    function findKey(object, predicate) {
      for (var key in object) {
        if (object.hasOwnProperty(key) && predicate(object[key])) {
          return key
        }
      }

      return undefined
    }

    function findIndex(array, predicate) {
      for (var key = 0; key < array.length; key++) {
        if (predicate(array[key])) {
          return key
        }
      }

      return undefined
    } // CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/_lib/buildMatchPatternFn/index.js
    function buildMatchPatternFn(args) {
      return function (string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}
        var matchResult = string.match(args.matchPattern)
        if (!matchResult) return null
        var matchedString = matchResult[0]
        var parseResult = string.match(args.parsePattern)
        if (!parseResult) return null
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0]
        value = options.valueCallback ? options.valueCallback(value) : value
        var rest = string.slice(matchedString.length)
        return {
          value: value,
          rest: rest
        }
      }
    } // CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/_lib/match/index.js
    var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i
    var parseOrdinalNumberPattern = /\d+/i
    var matchEraPatterns = {
      narrow: /^(b|a)/i,
      abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
      wide: /^(before christ|before common era|anno domini|common era)/i
    }
    var parseEraPatterns = {
      any: [/^b/i, /^(a|c)/i]
    }
    var matchQuarterPatterns = {
      narrow: /^[1234]/i,
      abbreviated: /^q[1234]/i,
      wide: /^[1234](th|st|nd|rd)? quarter/i
    }
    var parseQuarterPatterns = {
      any: [/1/i, /2/i, /3/i, /4/i]
    }
    var matchMonthPatterns = {
      narrow: /^[jfmasond]/i,
      abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
      wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
    }
    var parseMonthPatterns = {
      narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
      any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
    }
    var matchDayPatterns = {
      narrow: /^[smtwf]/i,
      short: /^(su|mo|tu|we|th|fr|sa)/i,
      abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
      wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
    }
    var parseDayPatterns = {
      narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
      any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
    }
    var matchDayPeriodPatterns = {
      narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
      any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
    }
    var parseDayPeriodPatterns = {
      any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
      }
    }
    var match = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function (value) {
          return parseInt(value, 10)
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function (index) {
          return index + 1
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
      })
    }
    /* harmony default export */ var _lib_match = match // CONCATENATED MODULE: ./node_modules/date-fns/esm/locale/en-US/index.js
    /**
     * @type {Locale}
     * @category Locales
     * @summary English locale (United States).
     * @language English
     * @iso-639-2 eng
     * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
     * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
     */

    var locale = {
      code: 'en-US',
      formatDistance: _lib_formatDistance,
      formatLong: _lib_formatLong,
      formatRelative: _lib_formatRelative,
      localize: _lib_localize,
      match: _lib_match,
      options: {
        weekStartsOn: 0,
        /* Sunday */
        firstWeekContainsDate: 1
      }
    }
    /* harmony default export */ var en_US = locale // CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/toInteger/index.js
    function toInteger(dirtyNumber) {
      if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
        return NaN
      }

      var number = Number(dirtyNumber)

      if (isNaN(number)) {
        return number
      }

      return number < 0 ? Math.ceil(number) : Math.floor(number)
    } // CONCATENATED MODULE: ./node_modules/date-fns/esm/addMilliseconds/index.js
    /**
     * @name addMilliseconds
     * @category Millisecond Helpers
     * @summary Add the specified number of milliseconds to the given date.
     *
     * @description
     * Add the specified number of milliseconds to the given date.
     *
     * ### v2.0.0 breaking changes:
     *
     * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
     *
     * @param {Date|Number} date - the date to be changed
     * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
     * @returns {Date} the new date with the milliseconds added
     * @throws {TypeError} 2 arguments required
     *
     * @example
     * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
     * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
     * //=> Thu Jul 10 2014 12:45:30.750
     */

    function addMilliseconds(dirtyDate, dirtyAmount) {
      requiredArgs(2, arguments)
      var timestamp = toDate(dirtyDate).getTime()
      var amount = toInteger(dirtyAmount)
      return new Date(timestamp + amount)
    } // CONCATENATED MODULE: ./node_modules/date-fns/esm/subMilliseconds/index.js
    /**
     * @name subMilliseconds
     * @category Millisecond Helpers
     * @summary Subtract the specified number of milliseconds from the given date.
     *
     * @description
     * Subtract the specified number of milliseconds from the given date.
     *
     * ### v2.0.0 breaking changes:
     *
     * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
     *
     * @param {Date|Number} date - the date to be changed
     * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
     * @returns {Date} the new date with the milliseconds subtracted
     * @throws {TypeError} 2 arguments required
     *
     * @example
     * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
     * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
     * //=> Thu Jul 10 2014 12:45:29.250
     */

    function subMilliseconds(dirtyDate, dirtyAmount) {
      requiredArgs(2, arguments)
      var amount = toInteger(dirtyAmount)
      return addMilliseconds(dirtyDate, -amount)
    } // CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/getUTCDayOfYear/index.js
    var MILLISECONDS_IN_DAY = 86400000 // This function will be a part of public API when UTC function will be implemented.
    // See issue: https://github.com/date-fns/date-fns/issues/376

    function getUTCDayOfYear(dirtyDate) {
      requiredArgs(1, arguments)
      var date = toDate(dirtyDate)
      var timestamp = date.getTime()
      date.setUTCMonth(0, 1)
      date.setUTCHours(0, 0, 0, 0)
      var startOfYearTimestamp = date.getTime()
      var difference = timestamp - startOfYearTimestamp
      return Math.floor(difference / MILLISECONDS_IN_DAY) + 1
    } // CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/startOfUTCISOWeek/index.js
    // This function will be a part of public API when UTC function will be implemented.
    // See issue: https://github.com/date-fns/date-fns/issues/376

    function startOfUTCISOWeek(dirtyDate) {
      requiredArgs(1, arguments)
      var weekStartsOn = 1
      var date = toDate(dirtyDate)
      var day = date.getUTCDay()
      var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn
      date.setUTCDate(date.getUTCDate() - diff)
      date.setUTCHours(0, 0, 0, 0)
      return date
    } // CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/getUTCISOWeekYear/index.js
    // This function will be a part of public API when UTC function will be implemented.
    // See issue: https://github.com/date-fns/date-fns/issues/376

    function getUTCISOWeekYear(dirtyDate) {
      requiredArgs(1, arguments)
      var date = toDate(dirtyDate)
      var year = date.getUTCFullYear()
      var fourthOfJanuaryOfNextYear = new Date(0)
      fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4)
      fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0)
      var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear)
      var fourthOfJanuaryOfThisYear = new Date(0)
      fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4)
      fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0)
      var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear)

      if (date.getTime() >= startOfNextYear.getTime()) {
        return year + 1
      } else if (date.getTime() >= startOfThisYear.getTime()) {
        return year
      } else {
        return year - 1
      }
    } // CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/startOfUTCISOWeekYear/index.js
    // This function will be a part of public API when UTC function will be implemented.
    // See issue: https://github.com/date-fns/date-fns/issues/376

    function startOfUTCISOWeekYear(dirtyDate) {
      requiredArgs(1, arguments)
      var year = getUTCISOWeekYear(dirtyDate)
      var fourthOfJanuary = new Date(0)
      fourthOfJanuary.setUTCFullYear(year, 0, 4)
      fourthOfJanuary.setUTCHours(0, 0, 0, 0)
      var date = startOfUTCISOWeek(fourthOfJanuary)
      return date
    } // CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/getUTCISOWeek/index.js
    var MILLISECONDS_IN_WEEK = 604800000 // This function will be a part of public API when UTC function will be implemented.
    // See issue: https://github.com/date-fns/date-fns/issues/376

    function getUTCISOWeek(dirtyDate) {
      requiredArgs(1, arguments)
      var date = toDate(dirtyDate)
      var diff = startOfUTCISOWeek(date).getTime() - startOfUTCISOWeekYear(date).getTime() // Round the number of days to the nearest integer
      // because the number of milliseconds in a week is not constant
      // (e.g. it's different in the week of the daylight saving time clock shift)

      return Math.round(diff / MILLISECONDS_IN_WEEK) + 1
    } // CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/startOfUTCWeek/index.js
    // This function will be a part of public API when UTC function will be implemented.
    // See issue: https://github.com/date-fns/date-fns/issues/376

    function startOfUTCWeek(dirtyDate, dirtyOptions) {
      requiredArgs(1, arguments)
      var options = dirtyOptions || {}
      var locale = options.locale
      var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn
      var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn)
      var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn) // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

      if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
        throw new RangeError('weekStartsOn must be between 0 and 6 inclusively')
      }

      var date = toDate(dirtyDate)
      var day = date.getUTCDay()
      var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn
      date.setUTCDate(date.getUTCDate() - diff)
      date.setUTCHours(0, 0, 0, 0)
      return date
    } // CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/getUTCWeekYear/index.js
    // This function will be a part of public API when UTC function will be implemented.
    // See issue: https://github.com/date-fns/date-fns/issues/376

    function getUTCWeekYear(dirtyDate, dirtyOptions) {
      requiredArgs(1, arguments)
      var date = toDate(dirtyDate)
      var year = date.getUTCFullYear()
      var options = dirtyOptions || {}
      var locale = options.locale
      var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate
      var defaultFirstWeekContainsDate =
        localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate)
      var firstWeekContainsDate =
        options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate) // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

      if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
        throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively')
      }

      var firstWeekOfNextYear = new Date(0)
      firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate)
      firstWeekOfNextYear.setUTCHours(0, 0, 0, 0)
      var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, dirtyOptions)
      var firstWeekOfThisYear = new Date(0)
      firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate)
      firstWeekOfThisYear.setUTCHours(0, 0, 0, 0)
      var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, dirtyOptions)

      if (date.getTime() >= startOfNextYear.getTime()) {
        return year + 1
      } else if (date.getTime() >= startOfThisYear.getTime()) {
        return year
      } else {
        return year - 1
      }
    } // CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/startOfUTCWeekYear/index.js
    // This function will be a part of public API when UTC function will be implemented.
    // See issue: https://github.com/date-fns/date-fns/issues/376

    function startOfUTCWeekYear(dirtyDate, dirtyOptions) {
      requiredArgs(1, arguments)
      var options = dirtyOptions || {}
      var locale = options.locale
      var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate
      var defaultFirstWeekContainsDate =
        localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate)
      var firstWeekContainsDate =
        options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate)
      var year = getUTCWeekYear(dirtyDate, dirtyOptions)
      var firstWeek = new Date(0)
      firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate)
      firstWeek.setUTCHours(0, 0, 0, 0)
      var date = startOfUTCWeek(firstWeek, dirtyOptions)
      return date
    } // CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/getUTCWeek/index.js
    var getUTCWeek_MILLISECONDS_IN_WEEK = 604800000 // This function will be a part of public API when UTC function will be implemented.
    // See issue: https://github.com/date-fns/date-fns/issues/376

    function getUTCWeek(dirtyDate, options) {
      requiredArgs(1, arguments)
      var date = toDate(dirtyDate)
      var diff = startOfUTCWeek(date, options).getTime() - startOfUTCWeekYear(date, options).getTime() // Round the number of days to the nearest integer
      // because the number of milliseconds in a week is not constant
      // (e.g. it's different in the week of the daylight saving time clock shift)

      return Math.round(diff / getUTCWeek_MILLISECONDS_IN_WEEK) + 1
    } // CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/addLeadingZeros/index.js
    function addLeadingZeros(number, targetLength) {
      var sign = number < 0 ? '-' : ''
      var output = Math.abs(number).toString()

      while (output.length < targetLength) {
        output = '0' + output
      }

      return sign + output
    } // CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/format/lightFormatters/index.js
    /*
     * |     | Unit                           |     | Unit                           |
     * |-----|--------------------------------|-----|--------------------------------|
     * |  a  | AM, PM                         |  A* |                                |
     * |  d  | Day of month                   |  D  |                                |
     * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
     * |  m  | Minute                         |  M  | Month                          |
     * |  s  | Second                         |  S  | Fraction of second             |
     * |  y  | Year (abs)                     |  Y  |                                |
     *
     * Letters marked by * are not implemented but reserved by Unicode standard.
     */

    var formatters = {
      // Year
      y: function (date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear() // Returns 1 for 1 BC (which is year 0 in JavaScript)

        var year = signedYear > 0 ? signedYear : 1 - signedYear
        return addLeadingZeros(token === 'yy' ? year % 100 : year, token.length)
      },
      // Month
      M: function (date, token) {
        var month = date.getUTCMonth()
        return token === 'M' ? String(month + 1) : addLeadingZeros(month + 1, 2)
      },
      // Day of the month
      d: function (date, token) {
        return addLeadingZeros(date.getUTCDate(), token.length)
      },
      // AM or PM
      a: function (date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am'

        switch (token) {
          case 'a':
          case 'aa':
            return dayPeriodEnumValue.toUpperCase()

          case 'aaa':
            return dayPeriodEnumValue

          case 'aaaaa':
            return dayPeriodEnumValue[0]

          case 'aaaa':
          default:
            return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.'
        }
      },
      // Hour [1-12]
      h: function (date, token) {
        return addLeadingZeros(date.getUTCHours() % 12 || 12, token.length)
      },
      // Hour [0-23]
      H: function (date, token) {
        return addLeadingZeros(date.getUTCHours(), token.length)
      },
      // Minute
      m: function (date, token) {
        return addLeadingZeros(date.getUTCMinutes(), token.length)
      },
      // Second
      s: function (date, token) {
        return addLeadingZeros(date.getUTCSeconds(), token.length)
      },
      // Fraction of second
      S: function (date, token) {
        var numberOfDigits = token.length
        var milliseconds = date.getUTCMilliseconds()
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3))
        return addLeadingZeros(fractionalSeconds, token.length)
      }
    }
    /* harmony default export */ var lightFormatters = formatters // CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/format/formatters/index.js
    var dayPeriodEnum = {
      am: 'am',
      pm: 'pm',
      midnight: 'midnight',
      noon: 'noon',
      morning: 'morning',
      afternoon: 'afternoon',
      evening: 'evening',
      night: 'night'
    }
    /*
     * |     | Unit                           |     | Unit                           |
     * |-----|--------------------------------|-----|--------------------------------|
     * |  a  | AM, PM                         |  A* | Milliseconds in day            |
     * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
     * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
     * |  d  | Day of month                   |  D  | Day of year                    |
     * |  e  | Local day of week              |  E  | Day of week                    |
     * |  f  |                                |  F* | Day of week in month           |
     * |  g* | Modified Julian day            |  G  | Era                            |
     * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
     * |  i! | ISO day of week                |  I! | ISO week of year               |
     * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
     * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
     * |  l* | (deprecated)                   |  L  | Stand-alone month              |
     * |  m  | Minute                         |  M  | Month                          |
     * |  n  |                                |  N  |                                |
     * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
     * |  p! | Long localized time            |  P! | Long localized date            |
     * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
     * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
     * |  s  | Second                         |  S  | Fraction of second             |
     * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
     * |  u  | Extended year                  |  U* | Cyclic year                    |
     * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
     * |  w  | Local week of year             |  W* | Week of month                  |
     * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
     * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
     * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
     *
     * Letters marked by * are not implemented but reserved by Unicode standard.
     *
     * Letters marked by ! are non-standard, but implemented by date-fns:
     * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
     * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
     *   i.e. 7 for Sunday, 1 for Monday, etc.
     * - `I` is ISO week of year, as opposed to `w` which is local week of year.
     * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
     *   `R` is supposed to be used in conjunction with `I` and `i`
     *   for universal ISO week-numbering date, whereas
     *   `Y` is supposed to be used in conjunction with `w` and `e`
     *   for week-numbering date specific to the locale.
     * - `P` is long localized date format
     * - `p` is long localized time format
     */

    var formatters_formatters = {
      // Era
      G: function (date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0

        switch (token) {
          // AD, BC
          case 'G':
          case 'GG':
          case 'GGG':
            return localize.era(era, {
              width: 'abbreviated'
            })
          // A, B

          case 'GGGGG':
            return localize.era(era, {
              width: 'narrow'
            })
          // Anno Domini, Before Christ

          case 'GGGG':
          default:
            return localize.era(era, {
              width: 'wide'
            })
        }
      },
      // Year
      y: function (date, token, localize) {
        // Ordinal number
        if (token === 'yo') {
          var signedYear = date.getUTCFullYear() // Returns 1 for 1 BC (which is year 0 in JavaScript)

          var year = signedYear > 0 ? signedYear : 1 - signedYear
          return localize.ordinalNumber(year, {
            unit: 'year'
          })
        }

        return lightFormatters.y(date, token)
      },
      // Local week-numbering year
      Y: function (date, token, localize, options) {
        var signedWeekYear = getUTCWeekYear(date, options) // Returns 1 for 1 BC (which is year 0 in JavaScript)

        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear // Two digit year

        if (token === 'YY') {
          var twoDigitYear = weekYear % 100
          return addLeadingZeros(twoDigitYear, 2)
        } // Ordinal number

        if (token === 'Yo') {
          return localize.ordinalNumber(weekYear, {
            unit: 'year'
          })
        } // Padding

        return addLeadingZeros(weekYear, token.length)
      },
      // ISO week-numbering year
      R: function (date, token) {
        var isoWeekYear = getUTCISOWeekYear(date) // Padding

        return addLeadingZeros(isoWeekYear, token.length)
      },
      // Extended year. This is a single number designating the year of this calendar system.
      // The main difference between `y` and `u` localizers are B.C. years:
      // | Year | `y` | `u` |
      // |------|-----|-----|
      // | AC 1 |   1 |   1 |
      // | BC 1 |   1 |   0 |
      // | BC 2 |   2 |  -1 |
      // Also `yy` always returns the last two digits of a year,
      // while `uu` pads single digit years to 2 characters and returns other years unchanged.
      u: function (date, token) {
        var year = date.getUTCFullYear()
        return addLeadingZeros(year, token.length)
      },
      // Quarter
      Q: function (date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3)

        switch (token) {
          // 1, 2, 3, 4
          case 'Q':
            return String(quarter)
          // 01, 02, 03, 04

          case 'QQ':
            return addLeadingZeros(quarter, 2)
          // 1st, 2nd, 3rd, 4th

          case 'Qo':
            return localize.ordinalNumber(quarter, {
              unit: 'quarter'
            })
          // Q1, Q2, Q3, Q4

          case 'QQQ':
            return localize.quarter(quarter, {
              width: 'abbreviated',
              context: 'formatting'
            })
          // 1, 2, 3, 4 (narrow quarter; could be not numerical)

          case 'QQQQQ':
            return localize.quarter(quarter, {
              width: 'narrow',
              context: 'formatting'
            })
          // 1st quarter, 2nd quarter, ...

          case 'QQQQ':
          default:
            return localize.quarter(quarter, {
              width: 'wide',
              context: 'formatting'
            })
        }
      },
      // Stand-alone quarter
      q: function (date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3)

        switch (token) {
          // 1, 2, 3, 4
          case 'q':
            return String(quarter)
          // 01, 02, 03, 04

          case 'qq':
            return addLeadingZeros(quarter, 2)
          // 1st, 2nd, 3rd, 4th

          case 'qo':
            return localize.ordinalNumber(quarter, {
              unit: 'quarter'
            })
          // Q1, Q2, Q3, Q4

          case 'qqq':
            return localize.quarter(quarter, {
              width: 'abbreviated',
              context: 'standalone'
            })
          // 1, 2, 3, 4 (narrow quarter; could be not numerical)

          case 'qqqqq':
            return localize.quarter(quarter, {
              width: 'narrow',
              context: 'standalone'
            })
          // 1st quarter, 2nd quarter, ...

          case 'qqqq':
          default:
            return localize.quarter(quarter, {
              width: 'wide',
              context: 'standalone'
            })
        }
      },
      // Month
      M: function (date, token, localize) {
        var month = date.getUTCMonth()

        switch (token) {
          case 'M':
          case 'MM':
            return lightFormatters.M(date, token)
          // 1st, 2nd, ..., 12th

          case 'Mo':
            return localize.ordinalNumber(month + 1, {
              unit: 'month'
            })
          // Jan, Feb, ..., Dec

          case 'MMM':
            return localize.month(month, {
              width: 'abbreviated',
              context: 'formatting'
            })
          // J, F, ..., D

          case 'MMMMM':
            return localize.month(month, {
              width: 'narrow',
              context: 'formatting'
            })
          // January, February, ..., December

          case 'MMMM':
          default:
            return localize.month(month, {
              width: 'wide',
              context: 'formatting'
            })
        }
      },
      // Stand-alone month
      L: function (date, token, localize) {
        var month = date.getUTCMonth()

        switch (token) {
          // 1, 2, ..., 12
          case 'L':
            return String(month + 1)
          // 01, 02, ..., 12

          case 'LL':
            return addLeadingZeros(month + 1, 2)
          // 1st, 2nd, ..., 12th

          case 'Lo':
            return localize.ordinalNumber(month + 1, {
              unit: 'month'
            })
          // Jan, Feb, ..., Dec

          case 'LLL':
            return localize.month(month, {
              width: 'abbreviated',
              context: 'standalone'
            })
          // J, F, ..., D

          case 'LLLLL':
            return localize.month(month, {
              width: 'narrow',
              context: 'standalone'
            })
          // January, February, ..., December

          case 'LLLL':
          default:
            return localize.month(month, {
              width: 'wide',
              context: 'standalone'
            })
        }
      },
      // Local week of year
      w: function (date, token, localize, options) {
        var week = getUTCWeek(date, options)

        if (token === 'wo') {
          return localize.ordinalNumber(week, {
            unit: 'week'
          })
        }

        return addLeadingZeros(week, token.length)
      },
      // ISO week of year
      I: function (date, token, localize) {
        var isoWeek = getUTCISOWeek(date)

        if (token === 'Io') {
          return localize.ordinalNumber(isoWeek, {
            unit: 'week'
          })
        }

        return addLeadingZeros(isoWeek, token.length)
      },
      // Day of the month
      d: function (date, token, localize) {
        if (token === 'do') {
          return localize.ordinalNumber(date.getUTCDate(), {
            unit: 'date'
          })
        }

        return lightFormatters.d(date, token)
      },
      // Day of year
      D: function (date, token, localize) {
        var dayOfYear = getUTCDayOfYear(date)

        if (token === 'Do') {
          return localize.ordinalNumber(dayOfYear, {
            unit: 'dayOfYear'
          })
        }

        return addLeadingZeros(dayOfYear, token.length)
      },
      // Day of week
      E: function (date, token, localize) {
        var dayOfWeek = date.getUTCDay()

        switch (token) {
          // Tue
          case 'E':
          case 'EE':
          case 'EEE':
            return localize.day(dayOfWeek, {
              width: 'abbreviated',
              context: 'formatting'
            })
          // T

          case 'EEEEE':
            return localize.day(dayOfWeek, {
              width: 'narrow',
              context: 'formatting'
            })
          // Tu

          case 'EEEEEE':
            return localize.day(dayOfWeek, {
              width: 'short',
              context: 'formatting'
            })
          // Tuesday

          case 'EEEE':
          default:
            return localize.day(dayOfWeek, {
              width: 'wide',
              context: 'formatting'
            })
        }
      },
      // Local day of week
      e: function (date, token, localize, options) {
        var dayOfWeek = date.getUTCDay()
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7

        switch (token) {
          // Numerical value (Nth day of week with current locale or weekStartsOn)
          case 'e':
            return String(localDayOfWeek)
          // Padded numerical value

          case 'ee':
            return addLeadingZeros(localDayOfWeek, 2)
          // 1st, 2nd, ..., 7th

          case 'eo':
            return localize.ordinalNumber(localDayOfWeek, {
              unit: 'day'
            })

          case 'eee':
            return localize.day(dayOfWeek, {
              width: 'abbreviated',
              context: 'formatting'
            })
          // T

          case 'eeeee':
            return localize.day(dayOfWeek, {
              width: 'narrow',
              context: 'formatting'
            })
          // Tu

          case 'eeeeee':
            return localize.day(dayOfWeek, {
              width: 'short',
              context: 'formatting'
            })
          // Tuesday

          case 'eeee':
          default:
            return localize.day(dayOfWeek, {
              width: 'wide',
              context: 'formatting'
            })
        }
      },
      // Stand-alone local day of week
      c: function (date, token, localize, options) {
        var dayOfWeek = date.getUTCDay()
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7

        switch (token) {
          // Numerical value (same as in `e`)
          case 'c':
            return String(localDayOfWeek)
          // Padded numerical value

          case 'cc':
            return addLeadingZeros(localDayOfWeek, token.length)
          // 1st, 2nd, ..., 7th

          case 'co':
            return localize.ordinalNumber(localDayOfWeek, {
              unit: 'day'
            })

          case 'ccc':
            return localize.day(dayOfWeek, {
              width: 'abbreviated',
              context: 'standalone'
            })
          // T

          case 'ccccc':
            return localize.day(dayOfWeek, {
              width: 'narrow',
              context: 'standalone'
            })
          // Tu

          case 'cccccc':
            return localize.day(dayOfWeek, {
              width: 'short',
              context: 'standalone'
            })
          // Tuesday

          case 'cccc':
          default:
            return localize.day(dayOfWeek, {
              width: 'wide',
              context: 'standalone'
            })
        }
      },
      // ISO day of week
      i: function (date, token, localize) {
        var dayOfWeek = date.getUTCDay()
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek

        switch (token) {
          // 2
          case 'i':
            return String(isoDayOfWeek)
          // 02

          case 'ii':
            return addLeadingZeros(isoDayOfWeek, token.length)
          // 2nd

          case 'io':
            return localize.ordinalNumber(isoDayOfWeek, {
              unit: 'day'
            })
          // Tue

          case 'iii':
            return localize.day(dayOfWeek, {
              width: 'abbreviated',
              context: 'formatting'
            })
          // T

          case 'iiiii':
            return localize.day(dayOfWeek, {
              width: 'narrow',
              context: 'formatting'
            })
          // Tu

          case 'iiiiii':
            return localize.day(dayOfWeek, {
              width: 'short',
              context: 'formatting'
            })
          // Tuesday

          case 'iiii':
          default:
            return localize.day(dayOfWeek, {
              width: 'wide',
              context: 'formatting'
            })
        }
      },
      // AM or PM
      a: function (date, token, localize) {
        var hours = date.getUTCHours()
        var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am'

        switch (token) {
          case 'a':
          case 'aa':
            return localize.dayPeriod(dayPeriodEnumValue, {
              width: 'abbreviated',
              context: 'formatting'
            })

          case 'aaa':
            return localize
              .dayPeriod(dayPeriodEnumValue, {
                width: 'abbreviated',
                context: 'formatting'
              })
              .toLowerCase()

          case 'aaaaa':
            return localize.dayPeriod(dayPeriodEnumValue, {
              width: 'narrow',
              context: 'formatting'
            })

          case 'aaaa':
          default:
            return localize.dayPeriod(dayPeriodEnumValue, {
              width: 'wide',
              context: 'formatting'
            })
        }
      },
      // AM, PM, midnight, noon
      b: function (date, token, localize) {
        var hours = date.getUTCHours()
        var dayPeriodEnumValue

        if (hours === 12) {
          dayPeriodEnumValue = dayPeriodEnum.noon
        } else if (hours === 0) {
          dayPeriodEnumValue = dayPeriodEnum.midnight
        } else {
          dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am'
        }

        switch (token) {
          case 'b':
          case 'bb':
            return localize.dayPeriod(dayPeriodEnumValue, {
              width: 'abbreviated',
              context: 'formatting'
            })

          case 'bbb':
            return localize
              .dayPeriod(dayPeriodEnumValue, {
                width: 'abbreviated',
                context: 'formatting'
              })
              .toLowerCase()

          case 'bbbbb':
            return localize.dayPeriod(dayPeriodEnumValue, {
              width: 'narrow',
              context: 'formatting'
            })

          case 'bbbb':
          default:
            return localize.dayPeriod(dayPeriodEnumValue, {
              width: 'wide',
              context: 'formatting'
            })
        }
      },
      // in the morning, in the afternoon, in the evening, at night
      B: function (date, token, localize) {
        var hours = date.getUTCHours()
        var dayPeriodEnumValue

        if (hours >= 17) {
          dayPeriodEnumValue = dayPeriodEnum.evening
        } else if (hours >= 12) {
          dayPeriodEnumValue = dayPeriodEnum.afternoon
        } else if (hours >= 4) {
          dayPeriodEnumValue = dayPeriodEnum.morning
        } else {
          dayPeriodEnumValue = dayPeriodEnum.night
        }

        switch (token) {
          case 'B':
          case 'BB':
          case 'BBB':
            return localize.dayPeriod(dayPeriodEnumValue, {
              width: 'abbreviated',
              context: 'formatting'
            })

          case 'BBBBB':
            return localize.dayPeriod(dayPeriodEnumValue, {
              width: 'narrow',
              context: 'formatting'
            })

          case 'BBBB':
          default:
            return localize.dayPeriod(dayPeriodEnumValue, {
              width: 'wide',
              context: 'formatting'
            })
        }
      },
      // Hour [1-12]
      h: function (date, token, localize) {
        if (token === 'ho') {
          var hours = date.getUTCHours() % 12
          if (hours === 0) hours = 12
          return localize.ordinalNumber(hours, {
            unit: 'hour'
          })
        }

        return lightFormatters.h(date, token)
      },
      // Hour [0-23]
      H: function (date, token, localize) {
        if (token === 'Ho') {
          return localize.ordinalNumber(date.getUTCHours(), {
            unit: 'hour'
          })
        }

        return lightFormatters.H(date, token)
      },
      // Hour [0-11]
      K: function (date, token, localize) {
        var hours = date.getUTCHours() % 12

        if (token === 'Ko') {
          return localize.ordinalNumber(hours, {
            unit: 'hour'
          })
        }

        return addLeadingZeros(hours, token.length)
      },
      // Hour [1-24]
      k: function (date, token, localize) {
        var hours = date.getUTCHours()
        if (hours === 0) hours = 24

        if (token === 'ko') {
          return localize.ordinalNumber(hours, {
            unit: 'hour'
          })
        }

        return addLeadingZeros(hours, token.length)
      },
      // Minute
      m: function (date, token, localize) {
        if (token === 'mo') {
          return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: 'minute'
          })
        }

        return lightFormatters.m(date, token)
      },
      // Second
      s: function (date, token, localize) {
        if (token === 'so') {
          return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: 'second'
          })
        }

        return lightFormatters.s(date, token)
      },
      // Fraction of second
      S: function (date, token) {
        return lightFormatters.S(date, token)
      },
      // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
      X: function (date, token, _localize, options) {
        var originalDate = options._originalDate || date
        var timezoneOffset = originalDate.getTimezoneOffset()

        if (timezoneOffset === 0) {
          return 'Z'
        }

        switch (token) {
          // Hours and optional minutes
          case 'X':
            return formatTimezoneWithOptionalMinutes(timezoneOffset)
          // Hours, minutes and optional seconds without `:` delimiter
          // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
          // so this token always has the same output as `XX`

          case 'XXXX':
          case 'XX':
            // Hours and minutes without `:` delimiter
            return formatTimezone(timezoneOffset)
          // Hours, minutes and optional seconds with `:` delimiter
          // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
          // so this token always has the same output as `XXX`

          case 'XXXXX':
          case 'XXX': // Hours and minutes with `:` delimiter

          default:
            return formatTimezone(timezoneOffset, ':')
        }
      },
      // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
      x: function (date, token, _localize, options) {
        var originalDate = options._originalDate || date
        var timezoneOffset = originalDate.getTimezoneOffset()

        switch (token) {
          // Hours and optional minutes
          case 'x':
            return formatTimezoneWithOptionalMinutes(timezoneOffset)
          // Hours, minutes and optional seconds without `:` delimiter
          // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
          // so this token always has the same output as `xx`

          case 'xxxx':
          case 'xx':
            // Hours and minutes without `:` delimiter
            return formatTimezone(timezoneOffset)
          // Hours, minutes and optional seconds with `:` delimiter
          // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
          // so this token always has the same output as `xxx`

          case 'xxxxx':
          case 'xxx': // Hours and minutes with `:` delimiter

          default:
            return formatTimezone(timezoneOffset, ':')
        }
      },
      // Timezone (GMT)
      O: function (date, token, _localize, options) {
        var originalDate = options._originalDate || date
        var timezoneOffset = originalDate.getTimezoneOffset()

        switch (token) {
          // Short
          case 'O':
          case 'OO':
          case 'OOO':
            return 'GMT' + formatTimezoneShort(timezoneOffset, ':')
          // Long

          case 'OOOO':
          default:
            return 'GMT' + formatTimezone(timezoneOffset, ':')
        }
      },
      // Timezone (specific non-location)
      z: function (date, token, _localize, options) {
        var originalDate = options._originalDate || date
        var timezoneOffset = originalDate.getTimezoneOffset()

        switch (token) {
          // Short
          case 'z':
          case 'zz':
          case 'zzz':
            return 'GMT' + formatTimezoneShort(timezoneOffset, ':')
          // Long

          case 'zzzz':
          default:
            return 'GMT' + formatTimezone(timezoneOffset, ':')
        }
      },
      // Seconds timestamp
      t: function (date, token, _localize, options) {
        var originalDate = options._originalDate || date
        var timestamp = Math.floor(originalDate.getTime() / 1000)
        return addLeadingZeros(timestamp, token.length)
      },
      // Milliseconds timestamp
      T: function (date, token, _localize, options) {
        var originalDate = options._originalDate || date
        var timestamp = originalDate.getTime()
        return addLeadingZeros(timestamp, token.length)
      }
    }

    function formatTimezoneShort(offset, dirtyDelimiter) {
      var sign = offset > 0 ? '-' : '+'
      var absOffset = Math.abs(offset)
      var hours = Math.floor(absOffset / 60)
      var minutes = absOffset % 60

      if (minutes === 0) {
        return sign + String(hours)
      }

      var delimiter = dirtyDelimiter || ''
      return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2)
    }

    function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
      if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+'
        return sign + addLeadingZeros(Math.abs(offset) / 60, 2)
      }

      return formatTimezone(offset, dirtyDelimiter)
    }

    function formatTimezone(offset, dirtyDelimiter) {
      var delimiter = dirtyDelimiter || ''
      var sign = offset > 0 ? '-' : '+'
      var absOffset = Math.abs(offset)
      var hours = addLeadingZeros(Math.floor(absOffset / 60), 2)
      var minutes = addLeadingZeros(absOffset % 60, 2)
      return sign + hours + delimiter + minutes
    }

    /* harmony default export */ var format_formatters = formatters_formatters // CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/format/longFormatters/index.js
    function dateLongFormatter(pattern, formatLong) {
      switch (pattern) {
        case 'P':
          return formatLong.date({
            width: 'short'
          })

        case 'PP':
          return formatLong.date({
            width: 'medium'
          })

        case 'PPP':
          return formatLong.date({
            width: 'long'
          })

        case 'PPPP':
        default:
          return formatLong.date({
            width: 'full'
          })
      }
    }

    function timeLongFormatter(pattern, formatLong) {
      switch (pattern) {
        case 'p':
          return formatLong.time({
            width: 'short'
          })

        case 'pp':
          return formatLong.time({
            width: 'medium'
          })

        case 'ppp':
          return formatLong.time({
            width: 'long'
          })

        case 'pppp':
        default:
          return formatLong.time({
            width: 'full'
          })
      }
    }

    function dateTimeLongFormatter(pattern, formatLong) {
      var matchResult = pattern.match(/(P+)(p+)?/) || []
      var datePattern = matchResult[1]
      var timePattern = matchResult[2]

      if (!timePattern) {
        return dateLongFormatter(pattern, formatLong)
      }

      var dateTimeFormat

      switch (datePattern) {
        case 'P':
          dateTimeFormat = formatLong.dateTime({
            width: 'short'
          })
          break

        case 'PP':
          dateTimeFormat = formatLong.dateTime({
            width: 'medium'
          })
          break

        case 'PPP':
          dateTimeFormat = formatLong.dateTime({
            width: 'long'
          })
          break

        case 'PPPP':
        default:
          dateTimeFormat = formatLong.dateTime({
            width: 'full'
          })
          break
      }

      return dateTimeFormat
        .replace('{{date}}', dateLongFormatter(datePattern, formatLong))
        .replace('{{time}}', timeLongFormatter(timePattern, formatLong))
    }

    var longFormatters = {
      p: timeLongFormatter,
      P: dateTimeLongFormatter
    }
    /* harmony default export */ var format_longFormatters = longFormatters // CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/getTimezoneOffsetInMilliseconds/index.js
    /**
     * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
     * They usually appear for dates that denote time before the timezones were introduced
     * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
     * and GMT+01:00:00 after that date)
     *
     * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
     * which would lead to incorrect calculations.
     *
     * This function returns the timezone offset in milliseconds that takes seconds in account.
     */
    function getTimezoneOffsetInMilliseconds(date) {
      var utcDate = new Date(
        Date.UTC(
          date.getFullYear(),
          date.getMonth(),
          date.getDate(),
          date.getHours(),
          date.getMinutes(),
          date.getSeconds(),
          date.getMilliseconds()
        )
      )
      utcDate.setUTCFullYear(date.getFullYear())
      return date.getTime() - utcDate.getTime()
    } // CONCATENATED MODULE: ./node_modules/date-fns/esm/_lib/protectedTokens/index.js
    var protectedDayOfYearTokens = ['D', 'DD']
    var protectedWeekYearTokens = ['YY', 'YYYY']
    function isProtectedDayOfYearToken(token) {
      return protectedDayOfYearTokens.indexOf(token) !== -1
    }
    function isProtectedWeekYearToken(token) {
      return protectedWeekYearTokens.indexOf(token) !== -1
    }
    function throwProtectedError(token, format, input) {
      if (token === 'YYYY') {
        throw new RangeError(
          'Use `yyyy` instead of `YYYY` (in `'
            .concat(format, '`) for formatting years to the input `')
            .concat(input, '`; see: https://git.io/fxCyr')
        )
      } else if (token === 'YY') {
        throw new RangeError(
          'Use `yy` instead of `YY` (in `'
            .concat(format, '`) for formatting years to the input `')
            .concat(input, '`; see: https://git.io/fxCyr')
        )
      } else if (token === 'D') {
        throw new RangeError(
          'Use `d` instead of `D` (in `'
            .concat(format, '`) for formatting days of the month to the input `')
            .concat(input, '`; see: https://git.io/fxCyr')
        )
      } else if (token === 'DD') {
        throw new RangeError(
          'Use `dd` instead of `DD` (in `'
            .concat(format, '`) for formatting days of the month to the input `')
            .concat(input, '`; see: https://git.io/fxCyr')
        )
      }
    } // CONCATENATED MODULE: ./node_modules/date-fns/esm/format/index.js
    // This RegExp consists of three parts separated by `|`:
    // - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
    //   (one of the certain letters followed by `o`)
    // - (\w)\1* matches any sequences of the same letter
    // - '' matches two quote characters in a row
    // - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
    //   except a single quote symbol, which ends the sequence.
    //   Two quote characters do not end the sequence.
    //   If there is no matching single quote
    //   then the sequence will continue until the end of the string.
    // - . matches any single character unmatched by previous parts of the RegExps

    var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g // This RegExp catches symbols escaped by quotes, and also
    // sequences of symbols P, p, and the combinations like `PPPPPPPppppp`

    var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g
    var escapedStringRegExp = /^'([^]*?)'?$/
    var doubleQuoteRegExp = /''/g
    var unescapedLatinCharacterRegExp = /[a-zA-Z]/
    /**
     * @name format
     * @category Common Helpers
     * @summary Format the date.
     *
     * @description
     * Return the formatted date string in the given format. The result may vary by locale.
     *
     * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
     * > See: https://git.io/fxCyr
     *
     * The characters wrapped between two single quotes characters (') are escaped.
     * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
     * (see the last example)
     *
     * Format of the string is based on Unicode Technical Standard #35:
     * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
     * with a few additions (see note 7 below the table).
     *
     * Accepted patterns:
     * | Unit                            | Pattern | Result examples                   | Notes |
     * |---------------------------------|---------|-----------------------------------|-------|
     * | Era                             | G..GGG  | AD, BC                            |       |
     * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
     * |                                 | GGGGG   | A, B                              |       |
     * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
     * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
     * |                                 | yy      | 44, 01, 00, 17                    | 5     |
     * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
     * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
     * |                                 | yyyyy   | ...                               | 3,5   |
     * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
     * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
     * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
     * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
     * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
     * |                                 | YYYYY   | ...                               | 3,5   |
     * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
     * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
     * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
     * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
     * |                                 | RRRRR   | ...                               | 3,5,7 |
     * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
     * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
     * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
     * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
     * |                                 | uuuuu   | ...                               | 3,5   |
     * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
     * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
     * |                                 | QQ      | 01, 02, 03, 04                    |       |
     * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
     * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
     * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
     * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
     * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
     * |                                 | qq      | 01, 02, 03, 04                    |       |
     * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
     * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
     * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
     * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
     * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
     * |                                 | MM      | 01, 02, ..., 12                   |       |
     * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
     * |                                 | MMMM    | January, February, ..., December  | 2     |
     * |                                 | MMMMM   | J, F, ..., D                      |       |
     * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
     * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
     * |                                 | LL      | 01, 02, ..., 12                   |       |
     * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
     * |                                 | LLLL    | January, February, ..., December  | 2     |
     * |                                 | LLLLL   | J, F, ..., D                      |       |
     * | Local week of year              | w       | 1, 2, ..., 53                     |       |
     * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
     * |                                 | ww      | 01, 02, ..., 53                   |       |
     * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
     * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
     * |                                 | II      | 01, 02, ..., 53                   | 7     |
     * | Day of month                    | d       | 1, 2, ..., 31                     |       |
     * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
     * |                                 | dd      | 01, 02, ..., 31                   |       |
     * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
     * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
     * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
     * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
     * |                                 | DDDD    | ...                               | 3     |
     * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
     * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
     * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
     * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
     * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
     * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
     * |                                 | ii      | 01, 02, ..., 07                   | 7     |
     * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
     * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
     * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
     * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
     * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
     * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
     * |                                 | ee      | 02, 03, ..., 01                   |       |
     * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
     * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
     * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
     * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
     * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
     * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
     * |                                 | cc      | 02, 03, ..., 01                   |       |
     * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
     * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
     * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
     * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
     * | AM, PM                          | a..aa   | AM, PM                            |       |
     * |                                 | aaa     | am, pm                            |       |
     * |                                 | aaaa    | a.m., p.m.                        | 2     |
     * |                                 | aaaaa   | a, p                              |       |
     * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
     * |                                 | bbb     | am, pm, noon, midnight            |       |
     * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
     * |                                 | bbbbb   | a, p, n, mi                       |       |
     * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
     * |                                 | BBBB    | at night, in the morning, ...     | 2     |
     * |                                 | BBBBB   | at night, in the morning, ...     |       |
     * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
     * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
     * |                                 | hh      | 01, 02, ..., 11, 12               |       |
     * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
     * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
     * |                                 | HH      | 00, 01, 02, ..., 23               |       |
     * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
     * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
     * |                                 | KK      | 01, 02, ..., 11, 00               |       |
     * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
     * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
     * |                                 | kk      | 24, 01, 02, ..., 23               |       |
     * | Minute                          | m       | 0, 1, ..., 59                     |       |
     * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
     * |                                 | mm      | 00, 01, ..., 59                   |       |
     * | Second                          | s       | 0, 1, ..., 59                     |       |
     * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
     * |                                 | ss      | 00, 01, ..., 59                   |       |
     * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
     * |                                 | SS      | 00, 01, ..., 99                   |       |
     * |                                 | SSS     | 000, 001, ..., 999                |       |
     * |                                 | SSSS    | ...                               | 3     |
     * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
     * |                                 | XX      | -0800, +0530, Z                   |       |
     * |                                 | XXX     | -08:00, +05:30, Z                 |       |
     * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
     * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
     * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
     * |                                 | xx      | -0800, +0530, +0000               |       |
     * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
     * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
     * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
     * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
     * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
     * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
     * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
     * | Seconds timestamp               | t       | 512969520                         | 7     |
     * |                                 | tt      | ...                               | 3,7   |
     * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
     * |                                 | TT      | ...                               | 3,7   |
     * | Long localized date             | P       | 04/29/1453                        | 7     |
     * |                                 | PP      | Apr 29, 1453                      | 7     |
     * |                                 | PPP     | April 29th, 1453                  | 7     |
     * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
     * | Long localized time             | p       | 12:00 AM                          | 7     |
     * |                                 | pp      | 12:00:00 AM                       | 7     |
     * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
     * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
     * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
     * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
     * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
     * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
     * Notes:
     * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
     *    are the same as "stand-alone" units, but are different in some languages.
     *    "Formatting" units are declined according to the rules of the language
     *    in the context of a date. "Stand-alone" units are always nominative singular:
     *
     *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
     *
     *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
     *
     * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
     *    the single quote characters (see below).
     *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
     *    the output will be the same as default pattern for this unit, usually
     *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
     *    are marked with "2" in the last column of the table.
     *
     *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
     *
     *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
     *
     *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
     *
     *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
     *
     *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
     *
     * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
     *    The output will be padded with zeros to match the length of the pattern.
     *
     *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
     *
     * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
     *    These tokens represent the shortest form of the quarter.
     *
     * 5. The main difference between `y` and `u` patterns are B.C. years:
     *
     *    | Year | `y` | `u` |
     *    |------|-----|-----|
     *    | AC 1 |   1 |   1 |
     *    | BC 1 |   1 |   0 |
     *    | BC 2 |   2 |  -1 |
     *
     *    Also `yy` always returns the last two digits of a year,
     *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
     *
     *    | Year | `yy` | `uu` |
     *    |------|------|------|
     *    | 1    |   01 |   01 |
     *    | 14   |   14 |   14 |
     *    | 376  |   76 |  376 |
     *    | 1453 |   53 | 1453 |
     *
     *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
     *    except local week-numbering years are dependent on `options.weekStartsOn`
     *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
     *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
     *
     * 6. Specific non-location timezones are currently unavailable in `date-fns`,
     *    so right now these tokens fall back to GMT timezones.
     *
     * 7. These patterns are not in the Unicode Technical Standard #35:
     *    - `i`: ISO day of week
     *    - `I`: ISO week of year
     *    - `R`: ISO week-numbering year
     *    - `t`: seconds timestamp
     *    - `T`: milliseconds timestamp
     *    - `o`: ordinal number modifier
     *    - `P`: long localized date
     *    - `p`: long localized time
     *
     * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
     *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
     *
     * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
     *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
     *
     * ### v2.0.0 breaking changes:
     *
     * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
     *
     * - The second argument is now required for the sake of explicitness.
     *
     *   ```javascript
     *   // Before v2.0.0
     *   format(new Date(2016, 0, 1))
     *
     *   // v2.0.0 onward
     *   format(new Date(2016, 0, 1), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
     *   ```
     *
     * - New format string API for `format` function
     *   which is based on [Unicode Technical Standard #35](https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table).
     *   See [this post](https://blog.date-fns.org/post/unicode-tokens-in-date-fns-v2-sreatyki91jg) for more details.
     *
     * - Characters are now escaped using single quote symbols (`'`) instead of square brackets.
     *
     * @param {Date|Number} date - the original date
     * @param {String} format - the string of tokens
     * @param {Object} [options] - an object with options.
     * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
     * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
     * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
     * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
     *   see: https://git.io/fxCyr
     * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
     *   see: https://git.io/fxCyr
     * @returns {String} the formatted date string
     * @throws {TypeError} 2 arguments required
     * @throws {RangeError} `date` must not be Invalid Date
     * @throws {RangeError} `options.locale` must contain `localize` property
     * @throws {RangeError} `options.locale` must contain `formatLong` property
     * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
     * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
     * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
     * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
     * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
     * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
     * @throws {RangeError} format string contains an unescaped latin alphabet character
     *
     * @example
     * // Represent 11 February 2014 in middle-endian format:
     * var result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
     * //=> '02/11/2014'
     *
     * @example
     * // Represent 2 July 2014 in Esperanto:
     * import { eoLocale } from 'date-fns/locale/eo'
     * var result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
     *   locale: eoLocale
     * })
     * //=> '2-a de julio 2014'
     *
     * @example
     * // Escape string by single quote characters:
     * var result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
     * //=> "3 o'clock"
     */

    function format(dirtyDate, dirtyFormatStr, dirtyOptions) {
      requiredArgs(2, arguments)
      var formatStr = String(dirtyFormatStr)
      var options = dirtyOptions || {}
      var locale = options.locale || en_US
      var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate
      var defaultFirstWeekContainsDate =
        localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate)
      var firstWeekContainsDate =
        options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate) // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

      if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
        throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively')
      }

      var localeWeekStartsOn = locale.options && locale.options.weekStartsOn
      var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn)
      var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn) // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

      if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
        throw new RangeError('weekStartsOn must be between 0 and 6 inclusively')
      }

      if (!locale.localize) {
        throw new RangeError('locale must contain localize property')
      }

      if (!locale.formatLong) {
        throw new RangeError('locale must contain formatLong property')
      }

      var originalDate = toDate(dirtyDate)

      if (!isValid(originalDate)) {
        throw new RangeError('Invalid time value')
      } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
      // This ensures that when UTC functions will be implemented, locales will be compatible with them.
      // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376

      var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate)
      var utcDate = subMilliseconds(originalDate, timezoneOffset)
      var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
      }
      var result = formatStr
        .match(longFormattingTokensRegExp)
        .map(function (substring) {
          var firstCharacter = substring[0]

          if (firstCharacter === 'p' || firstCharacter === 'P') {
            var longFormatter = format_longFormatters[firstCharacter]
            return longFormatter(substring, locale.formatLong, formatterOptions)
          }

          return substring
        })
        .join('')
        .match(formattingTokensRegExp)
        .map(function (substring) {
          // Replace two single quote characters with one single quote character
          if (substring === "''") {
            return "'"
          }

          var firstCharacter = substring[0]

          if (firstCharacter === "'") {
            return cleanEscapedString(substring)
          }

          var formatter = format_formatters[firstCharacter]

          if (formatter) {
            if (!options.useAdditionalWeekYearTokens && isProtectedWeekYearToken(substring)) {
              throwProtectedError(substring, dirtyFormatStr, dirtyDate)
            }

            if (!options.useAdditionalDayOfYearTokens && isProtectedDayOfYearToken(substring)) {
              throwProtectedError(substring, dirtyFormatStr, dirtyDate)
            }

            return formatter(utcDate, substring, locale.localize, formatterOptions)
          }

          if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
            throw new RangeError(
              'Format string contains an unescaped latin alphabet character `' + firstCharacter + '`'
            )
          }

          return substring
        })
        .join('')
      return result
    }

    function cleanEscapedString(input) {
      return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'")
    } // CONCATENATED MODULE: ./src/js/components/PreOrderNote.jsx
    /* provided dependency */ var MinimogSettings = __webpack_require__(4558)['MinimogSettings']
    /* provided dependency */ var PreOrderNote_createElement = __webpack_require__(6295)['default']
    /* provided dependency */ var i18n = __webpack_require__(7345)['default']

    function PreOrderNote(_ref) {
      let { settings } = _ref
      const { discount, eta, show_eta, active_discount, end_time, set_end_time } = settings
      const { money_format } = MinimogSettings
      const rate = Number(window.Shopify?.currency?.rate || 1)
      const discountValue =
        discount.type === 'PERCENTAGE' ? `${discount.value}%` : formatMoney(discount.value * 100 * rate, money_format)
      const discountTitle = PreOrderNote_createElement('li', null)
      const shippingNote = PreOrderNote_createElement('li', null)
      const endTimeNode = PreOrderNote_createElement('li', null)
      const date_format = i18n.tr('date_format')

      if (active_discount && discount.value) {
        discountTitle.innerHTML = i18n.tr('preorder_discount_title', {
          discount_value: discountValue
        })
      }

      if (eta && show_eta) {
        shippingNote.innerHTML = i18n.tr('preorder_shipping_note', {
          eta: format(new Date(eta), date_format)
        })
      }

      if (end_time) {
        endTimeNode.innerHTML = i18n.tr('preorder_end_note', {
          end_time: format(new Date(end_time), date_format)
        })
      }

      return PreOrderNote_createElement(
        'ul',
        {
          className: 'foxkit-preorder-note'
        },
        active_discount && discount?.value ? discountTitle : null,
        show_eta && eta ? shippingNote : null,
        set_end_time && end_time ? endTimeNode : null
      )
    }
    // EXTERNAL MODULE: ./node_modules/scroll-into-view/scrollIntoView.js
    var scroll_into_view_scrollIntoView = __webpack_require__(643) // CONCATENATED MODULE: ./src/js/utilities/load-assets.js
    function load_assets_loadJS(src) {
      let target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document.body
      let async = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false
      let defer = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true
      return new Promise((resolve, reject) => {
        const doc = target.ownerDocument
        const currScript = doc.querySelector(`script[src="${src}"]`)

        if (currScript) {
          if (currScript.dataset.loaded) return resolve(true)
          currScript.addEventListener('load', () => {
            currScript.dataset.loaded = true
            resolve(true)
          })
          return
        }

        const script = doc.createElement('script')
        script.src = src
        script.async = async
        script.defer = defer
        script.addEventListener('load', () => {
          script.dataset.loaded = true
          resolve(true)
        })
        script.onerror = reject
        target.appendChild(script)
      })
    }
    function load_assets_loadCSS(href) {
      let target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document.head
      return new Promise((resolve, reject) => {
        const doc = target.ownerDocument
        const currLink = doc.querySelector(`link[href="${href}"]`)

        if (currLink) {
          if (currLink.dataset.loaded) return resolve(true)
          currLink.addEventListener('load', () => {
            currLink.dataset.loaded = true
            resolve(true)
          })
          return
        }

        const link = doc.createElement('link')
        link.rel = 'stylesheet'
        link.href = href
        link.addEventListener('load', () => {
          link.dataset.loaded = true
          resolve(true)
        })
        link.onerror = reject
        target.appendChild(link)
      })
    }
    const { themeScriptURLs, themeStyleURLs } = window
    if (!themeScriptURLs || !themeStyleURLs) console.warn('Missing Assest URLs source')
    const themeAssets = {
      js: {
        urls: themeScriptURLs,
        load: load_assets_loadJS
      },
      css: {
        urls: themeStyleURLs,
        load: load_assets_loadCSS
      }
    }

    function log(asset) {
      console.groupCollapsed('%c Asset loaded: ', '#f7a046', asset)
      console.trace()
      console.groupEnd()
    }

    function load_assets_loadAssets(param) {
      for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        rest[_key - 1] = arguments[_key]
      }

      return new Promise((resolve, reject) => {
        const files = typeof param === 'string' ? [param] : param
        Promise.all(
          files.map(async (file) => {
            try {
              const [, name, type] = file.match(/(.*)\.(js|css)$/) || [, file, 'js']
              const {
                urls: {
                  [name]: { url }
                },
                load
              } = themeAssets[type]
              await load(url, ...rest)
              log(`${name}.${type}`)
            } catch (err) {
              console.warn(`Failed to load asset: ${file}.`, err)
            }
          })
        )
          .then(resolve)
          .catch(reject)
      })
    } // CONCATENATED MODULE: ./src/js/utilities/index.js
    /* provided dependency */ var utilities_MinimogSettings = __webpack_require__(4558)['MinimogSettings']
    /* provided dependency */ var utilities_createElement = __webpack_require__(6295)['default']

    window.__getSectionInstanceByType = (type) =>
      window.Shopify.theme.sections.instances.find((inst) => inst.type === type)

    function productFormCheck(form) {
      const fieldSelectors = '[data-theme-fields] [name][required]:not([hidden]):not([type="hidden"])'
      const requiredFields = form.querySelectorAll(fieldSelectors)
      const missingFields = []
      requiredFields.forEach((field) => {
        if (field.type === 'radio') {
          const raidoButtons = form.querySelectorAll(`input[name="${field.name}"]`)
          const selected = Array.from(raidoButtons).some((btn) => btn.checked)

          if (!selected) {
            missingFields.push(field)
          }
        } else if (!field.value) {
          missingFields.push(field)
        }
      })
      return missingFields
    }
    function queryDomNodes() {
      let selectors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}
      let context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document
      const domNodes = Object.entries(selectors).reduce((acc, _ref) => {
        let [name, selector] = _ref
        const findOne = typeof selector === 'string'
        const queryMethod = findOne ? 'querySelector' : 'querySelectorAll'
        const sl = findOne ? selector : selector[0]
        acc[name] = context?.[queryMethod]?.(sl)

        if (!findOne && acc[name]) {
          acc[name] = [...acc[name]]
        }

        return acc
      }, {})
      return domNodes
    }
    const camelCaseToSnakeCase = (str) => str.replace(/[A-Z]/g, ($1) => `_${$1.toLowerCase()}`)
    function animateReplace(oldNode, newNode) {
      if (!oldNode || !newNode) {
        return
      }

      oldNode.classList.add('ar__old-node')
      newNode.classList.add('ar__new-node')
      oldNode.style.opacity = 0
      oldNode.replaceWith(newNode)
      setTimeout(() => (newNode.style.opacity = 1))
    }
    function createSearchLink(query) {
      const searchParams = new URLSearchParams({
        type: 'product',
        ['options[unavailable_products]']: 'last',
        ['options[prefix]']: 'last',
        q: query
      })
      return `${PredictiveSearch.SEARCH_PATH}?${searchParams.toString()}`
    }
    function isInViewport(elem) {
      const rect = elem.getBoundingClientRect() // NOTE: not accuracy in all cases but we only need this

      return rect.top > 0 && rect.top < (window.innerHeight || document.documentElement.clientHeight)
    }

    function loadStyles() {
      const { themeStyleURLs = {} } = window
      Object.values(themeStyleURLs).forEach((style) => {
        const { url, required, afterWindowLoaded } = style

        if (url && required) {
          if (!afterWindowLoaded || window?.__sfWindowLoaded) {
            loadCSS(url)
          } else {
            window.addEventListener('load', () => loadCSS(url))
          }
        }
      })
    }

    function loadScripts() {
      const { themeScriptURLs = {} } = window
      Object.values(themeScriptURLs).forEach((script) => {
        const { url, required, afterWindowLoaded } = script

        if (url && required) {
          if (!afterWindowLoaded || window?.__sfWindowLoaded) {
            loadJS(url)
          } else {
            window.addEventListener('load', () => loadJS(url))
          }
        }
      })
    }

    function addCustomerFormHandlers() {
      addEventDelegate({
        selector: '.sf-customer__forms',
        handler: (e, form) => {
          if (e.target.classList.contains('sf-customer__reset-password-btn')) {
            form.classList.add('show-recover-password-form')
            return
          }

          if (e.target.classList.contains('sf-customer__cancel-reset')) {
            form.classList.remove('show-recover-password-form')
            return
          }
        }
      })

      if (document.querySelector('.sf-customer__recover-form-posted')) {
        document.querySelector('.sf-customer__forms')?.classList?.add('show-recover-password-form')
      }
    }

    function getVideoURL(id, host) {
      if (host === 'youtube') {
        return `https://www.youtube.com/watch?v=${id}&gl=true`
      }

      if (host === 'vimeo') {
        return `https://vimeo.com/${id}`
      }

      return ''
    }

    function showCookieConsent() {
      const { show_cookie_consent } = utilities_MinimogSettings
      const cookieAccepted = getCookie('cookieconsent_status')

      if (show_cookie_consent && !cookieAccepted) {
        loadAssets(['cookieConsent.css', 'cookieConsent.js'])
      }
    }

    function initTermsCheckbox() {
      addEventDelegate({
        selector: '.agree-terms [name="agree_terms"]',
        event: 'change',
        handler: (e, target) => {
          const button = target.closest('.agree-terms').nextElementSibling

          if (button && button.hasAttributes('data-terms-action')) {
            if (target.checked) {
              button.removeAttribute('disabled')
            } else {
              button.setAttribute('disabled', true)
            }
          }
        }
      })
    }

    const scrollToTopTarget = document.querySelector('#scroll-to-top-target')
    function scrollToTop(callback) {
      scrollIntoView(scrollToTopTarget, callback)
    }

    function initScrollTop() {
      const scrollTopButton = document.querySelector('#scroll-to-top-button')

      if (scrollTopButton) {
        scrollTopButton.addEventListener('click', scrollToTop)
        window.addEventListener('scroll', function () {
          const method = window.scrollY > 100 ? 'add' : 'remove'
          scrollTopButton.classList[method]('opacity-100')
        })
      }
    }

    function setCookie(cname, cvalue, exdays) {
      var d = new Date()
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
      var expires = 'expires=' + d.toUTCString()
      document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/'
    }
    function getCookie(cname) {
      var name = cname + '='
      var decodedCookie = decodeURIComponent(document.cookie)
      var ca = decodedCookie.split(';')

      for (var i = 0; i < ca.length; i++) {
        var c = ca[i]

        while (c.charAt(0) === ' ') {
          c = c.substring(1)
        }

        if (c.indexOf(name) === 0) {
          return c.substring(name.length, c.length)
        }
      }

      return ''
    }
    function addRecentViewedProduct() {
      const cookies = getCookie('sf-recent-viewed-products')
      let products = cookies ? JSON.parse(cookies) : []

      if (products.indexOf(utilities_MinimogSettings.productHandle) === -1) {
        products.unshift(utilities_MinimogSettings.productHandle)
        products = products.slice(0, 20)
        setCookie('sf-recent-viewed-products', JSON.stringify(products))
      }
    }
    const generateDomFromString = (value) => {
      const d = utilities_createElement('div', null)
      d.innerHTML = value
      return d
    }
    function emailIsValid(email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
    }
    function updateParam(key, value) {
      var { location } = window
      var baseUrl = [location.protocol, '//', location.host, location.pathname].join('')
      const queryString = window.location.search
      const urlParams = new URLSearchParams(queryString)

      if (urlParams.has(key)) {
        if (value !== '' && value !== 'undefined') {
          urlParams.set(key, value)
        }

        if (value === '' || value === 'undefined') {
          urlParams.delete(key)
        }
      } else {
        if (value) urlParams.append(key, value)
      }

      window.history.replaceState({}, '', baseUrl + '?' + urlParams.toString())
      return false
    }
    function getParams() {
      let params = {}
      const queryString = window.location.search
      const urlParams = new URLSearchParams(queryString)

      for (const entry of urlParams.entries()) {
        params[entry[0]] = entry[1]
      }

      return params
    }

    const setSwatchesOptions = () => {
      try {
        utilities_MinimogSettings._colorSwatches = []
        utilities_MinimogSettings._imageSwatches = []
        utilities_MinimogSettings.product_colors
          .split(',')
          .filter(Boolean)
          .forEach((colorSwatch) => {
            const [key, value] = colorSwatch.split(':')

            utilities_MinimogSettings._colorSwatches.push({
              key: key.trim().toLowerCase(),
              value: value?.trim?.() || ''
            })
          })
        Object.keys(utilities_MinimogSettings).forEach((key) => {
          if (key.includes('filter_color') && !key.includes('.png')) {
            if (utilities_MinimogSettings[`${key}.png`]) {
              utilities_MinimogSettings._imageSwatches.push({
                key: utilities_MinimogSettings[key].toLowerCase(),
                value: utilities_MinimogSettings[`${key}.png`]
              })
            }
          }
        })
      } catch (e) {
        console.error('Failed to convert color/image swatch structure!', e)
      }
    }

    const refreshProductReview = () => {
      if (typeof SMARTIFYAPPS !== 'undefined' && SMARTIFYAPPS.rv.installed) {
        SMARTIFYAPPS.rv.scmReviewsRate.actionCreateReviews()
      }

      if (typeof Yotpo !== 'undefined' && typeof Yotpo.API === 'function') {
        const yotpoApi = new Yotpo.API(yotpo)
        yotpoApi?.refreshWidgets()
      }
    }
    const formatUrl = (pageType, handle, query) => {
      let url
      const { routes } = utilities_MinimogSettings
      const root = routes.root.endsWith('/') ? '' : routes.root
      url = `${root}/${pageType}/${handle}`
      if (query) url += `?${query}`
      return url
    }
    function runHelpers() {
      try {
        loadScripts()
        loadStyles() ////////////////////

        setSwatchesOptions()
        showCookieConsent()
        initTermsCheckbox()
        initLocalization()
        addCustomerFormHandlers()
        initScrollTop()
      } catch (err) {
        console.error('Failed to run helpers.', err)
      }
    } // CONCATENATED MODULE: ./src/js/modules/product-quick-view.js
    /* provided dependency */ var product_quick_view_createElement = __webpack_require__(6295)['default']
    /* provided dependency */ var MinimogTheme = __webpack_require__(4558)['MinimogTheme']
    /* provided dependency */ var MinimogEvents = __webpack_require__(4558)['MinimogEvents']

    // eslint-disable-next-line no-unused-vars

    class ProductQuickView {
      constructor() {
        ;(0, defineProperty /* default */.Z)(this, 'products', {})

        ;(0, defineProperty /* default */.Z)(this, 'selectors', {
          formActions: '[data-cart-actions]'
        })

        ;(0, defineProperty /* default */.Z)(this, 'isOpen', false)

        ;(0, defineProperty /* default */.Z)(this, 'init', () => {
          ;(0, events /* addEventDelegate */.X)({
            selector: '.sf-pqv__button',
            handler: async (e, btn) => {
              try {
                e.preventDefault()
                const { productHandle, favId, favSku } = btn?.dataset || {}
                let quickView = this.products?.[productHandle]?.quickView

                if (!quickView) {
                  this.toggleLoading({
                    btn,
                    loading: true
                  })
                  const prodQuickviewURL = formatUrl('products', productHandle, 'view=quickview')
                  const quickViewHTML = await fetchCache(prodQuickviewURL)
                  quickView = product_quick_view_createElement('div', {
                    classList: 'hidden'
                  })
                  quickView.innerHTML = quickViewHTML
                  let qs = quickViewHTML.match(/<script.*?>([\s\S]+?)<\/script>/) || []
                  let str = qs[1]?.match(/window.product_sale_status = ([\s\S]+?);/) || ''
                  let productSaleStatus = JSON.parse(str[1]) || {}
                  // console.log('quickview productSaleStatus', str, productSaleStatus)
                  window.product_sale_status = productSaleStatus
                  document.body.appendChild(quickView)
                  MinimogTheme.Products.initProductForms().catch(console.error)
                  this.products[productHandle] = {
                    quickView
                  }
                  this.domNodes = queryDomNodes(this.selectors, this.Modal)
                }

                if (quickView) {
                  this.Modal.appendChild(quickView) // Modal.setSizes('w-5/6 md:w-4/5 lg:w-3/4 xl:w-2/3 2xl:w-1/2')

                  this.Modal.setWidth('960px')
                  this.Modal.setSizes('sf-modal__quickview')
                  quickView?.classList?.remove('hidden')
                  this.Modal.open()
                  this.toggleLoading({
                    btn,
                    loading: false
                  })
                  this.isOpen = true
                }

                /* Google GA4 Code */
                const coreGoogleGtag = window.CORE_GOOGLEGTAG
                if (coreGoogleGtag) {
                  coreGoogleGtag._hanldeEventViewItemByItemsKey(btn, favId, favSku)
                }

                /* Footwear Product Sizes */
                let moduleProduct = window.MODULE_PRODUCT
                let coreProduct = window.CORE_PRODUCT
                if (moduleProduct && coreProduct) {
                  const productList = moduleProduct.currentPageProductList
                  const product = productList.find(e => e.handle === productHandle)
                  coreProduct._handleFootwearProductsSizes?.(".sf-modal__quickview", product)
                }
              } catch (error) {
                this.toggleLoading({
                  btn,
                  loading: false
                })
                console.error('Failed to open product-quickview.', error)
              }
            }
          })
        })

        ;(0, defineProperty /* default */.Z)(this, 'close', (e) => {
          this.Modal.close(e)
          this.isOpen = false
        })

        ;(0, defineProperty /* default */.Z)(this, 'renderPreOrderNote', () => {
          let discount = {}
          discount.value = this.preorderDiscount
          discount.type = this.preorderDiscountType
          const eta = this.preorderEta
          const settings = {
            discount,
            eta
          }
          this.domNodes?.formActions?.appendChild(
            product_quick_view_createElement(PreOrderNote, {
              settings: settings
            })
          )
        })

        ;(0, defineProperty /* default */.Z)(this, 'toggleLoading', (_ref) => {
          let { btn, loading } = _ref

          if (loading) {
            btn.classList.add('sf-spinner-loading')
            btn.appendChild(this.spinner)
          } else {
            this?.spinner?.remove()
            btn.classList.remove('sf-spinner-loading')
          }
        })

        this.spinner = product_quick_view_createElement(Spinner, null)
        this.init()
        this.Modal = new modal()
      }
    }

    MinimogTheme = MinimogTheme || {}
    MinimogTheme.ProductQuickView = new ProductQuickView()
    MinimogEvents.subscribe('ON_ITEM_ADDED', () => MinimogTheme.ProductQuickView.close())
  })()
  /******/
})()
